"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARSE_APP_DATABASE = exports.AgentsPlanType = exports.AgentStatus = exports.ChatMessageAttachmentStatus = exports.ChatMessageStatus = exports.ChatType = exports.DeploymentLogLevel = exports.DeploymentStatus = exports.CustomDomainStatus = exports.AppPlanStatus = exports.AppStatus = exports.ProjectType = exports.TaskStatus = exports.OB_KEY = exports.NEW_QUESTIONNAIRE_ID = exports.OLD_QUESTIONNAIRE_ID = void 0;
var cross_fetch_1 = require("cross-fetch");
var graphql_ws_1 = require("graphql-ws");
var core_1 = require("@apollo/client/core");
var utilities_1 = require("@apollo/client/utilities");
var subscriptions_1 = require("@apollo/client/link/subscriptions");
var errors_1 = require("@back4app2/errors");
var HTTP_URL = process.env.BACK4APP2_SDK_HTTP_URL || 'http://localhost:4040/';
var WS_URL = process.env.BACK4APP2_SDK_WS_URL;
var SESSION_ID_HEADER = 'x-back4app2-session-id';
exports.OLD_QUESTIONNAIRE_ID = 'questionnaire-1';
exports.NEW_QUESTIONNAIRE_ID = 'questionnaire-2';
exports.OB_KEY = 'OBAIDONE';
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["WAITING"] = "WAITING";
    TaskStatus["DOING"] = "DOING";
    TaskStatus["DONE"] = "DONE";
    TaskStatus["FAILED"] = "FAILED";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
var ProjectType;
(function (ProjectType) {
    ProjectType["DOCKER"] = "DOCKER";
})(ProjectType = exports.ProjectType || (exports.ProjectType = {}));
var AppStatus;
(function (AppStatus) {
    AppStatus["INITIALIZING"] = "INITIALIZING";
    AppStatus["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    AppStatus["INITIALIZED"] = "INITIALIZED";
    AppStatus["FAILED"] = "FAILED";
})(AppStatus = exports.AppStatus || (exports.AppStatus = {}));
var AppPlanStatus;
(function (AppPlanStatus) {
    AppPlanStatus["REGULAR"] = "REGULAR";
    AppPlanStatus["OVER_LIMITS"] = "OVER_LIMITS";
})(AppPlanStatus = exports.AppPlanStatus || (exports.AppPlanStatus = {}));
var CustomDomainStatus;
(function (CustomDomainStatus) {
    CustomDomainStatus["INITIALIZING"] = "INITIALIZING";
    CustomDomainStatus["INITIALIZED"] = "INITIALIZED";
    CustomDomainStatus["AWAITING_DNS"] = "AWAITING_DNS";
    CustomDomainStatus["GENERATING_SSL"] = "GENERATING_SSL";
    CustomDomainStatus["RELEASING"] = "RELEASING";
    CustomDomainStatus["READY"] = "READY";
    CustomDomainStatus["DELETING"] = "DELETING";
    CustomDomainStatus["FAILED"] = "FAILED";
    CustomDomainStatus["EXPIRING"] = "EXPIRING";
    CustomDomainStatus["EXPIRED"] = "EXPIRED";
})(CustomDomainStatus = exports.CustomDomainStatus || (exports.CustomDomainStatus = {}));
var DeploymentStatus;
(function (DeploymentStatus) {
    DeploymentStatus["INITIALIZING"] = "INITIALIZING";
    DeploymentStatus["INITIALIZED"] = "INITIALIZED";
    DeploymentStatus["DEPLOYING"] = "DEPLOYING";
    DeploymentStatus["QUEUED"] = "QUEUED";
    DeploymentStatus["READY"] = "READY";
    DeploymentStatus["SLEEPY"] = "SLEEPY";
    DeploymentStatus["SLEEPING"] = "SLEEPING";
    DeploymentStatus["WAKING_UP"] = "WAKING_UP";
    DeploymentStatus["RENEWING"] = "RENEWING";
    DeploymentStatus["DESTROYING"] = "DESTROYING";
    DeploymentStatus["DESTROYED"] = "DESTROYED";
    DeploymentStatus["CANCELING"] = "CANCELING";
    DeploymentStatus["CANCELED"] = "CANCELED";
    DeploymentStatus["FAILED"] = "FAILED";
})(DeploymentStatus = exports.DeploymentStatus || (exports.DeploymentStatus = {}));
var DeploymentLogLevel;
(function (DeploymentLogLevel) {
    DeploymentLogLevel["INFO"] = "INFO";
    DeploymentLogLevel["WARNING"] = "WARNING";
    DeploymentLogLevel["ERROR"] = "ERROR";
    DeploymentLogLevel["SYSTEM"] = "SYSTEM";
})(DeploymentLogLevel = exports.DeploymentLogLevel || (exports.DeploymentLogLevel = {}));
var ChatType;
(function (ChatType) {
    ChatType["DEPLOYMENT_ERROR"] = "DEPLOYMENT_ID";
    ChatType["AGENT"] = "AGENT";
    ChatType["ONBOARDING_SUGGESTION"] = "ONBOARDING_SUGGESTION";
})(ChatType = exports.ChatType || (exports.ChatType = {}));
var ChatMessageStatus;
(function (ChatMessageStatus) {
    ChatMessageStatus["INITIALIZING"] = "INITIALIZING";
    ChatMessageStatus["INITIALIZED"] = "INITIALIZED";
    ChatMessageStatus["RESPONDING"] = "RESPONDING";
    ChatMessageStatus["RESPONDED"] = "RESPONDED";
    ChatMessageStatus["FAILED"] = "FAILED";
})(ChatMessageStatus = exports.ChatMessageStatus || (exports.ChatMessageStatus = {}));
var ChatMessageAttachmentStatus;
(function (ChatMessageAttachmentStatus) {
    ChatMessageAttachmentStatus["TEMPORARY"] = "TEMPORARY";
    ChatMessageAttachmentStatus["PERMANENT"] = "PERMANENT";
})(ChatMessageAttachmentStatus = exports.ChatMessageAttachmentStatus || (exports.ChatMessageAttachmentStatus = {}));
;
var AgentStatus;
(function (AgentStatus) {
    AgentStatus["INITIALIZING"] = "INITIALIZING";
    AgentStatus["INITIALIZED"] = "INITIALIZED";
    AgentStatus["LAUNCHING"] = "LAUNCHING";
    AgentStatus["READY"] = "READY";
    AgentStatus["SLEEPY"] = "SLEEPY";
    AgentStatus["SLEEPING"] = "SLEEPING";
    AgentStatus["WAKING_UP"] = "WAKING_UP";
    AgentStatus["RENEWING"] = "RENEWING";
    AgentStatus["FAILED"] = "FAILED";
})(AgentStatus = exports.AgentStatus || (exports.AgentStatus = {}));
var AgentsPlanType;
(function (AgentsPlanType) {
    AgentsPlanType["FREE"] = "FREE";
    AgentsPlanType["PAID"] = "PAID";
})(AgentsPlanType = exports.AgentsPlanType || (exports.AgentsPlanType = {}));
var PARSE_APP_DATABASE;
(function (PARSE_APP_DATABASE) {
    PARSE_APP_DATABASE["POSTGRESQL"] = "postgresql";
    PARSE_APP_DATABASE["NOSQL"] = "mongoDB";
})(PARSE_APP_DATABASE = exports.PARSE_APP_DATABASE || (exports.PARSE_APP_DATABASE = {}));
var Back4app2 = /** @class */ (function () {
    function Back4app2(config) {
        var _this = this;
        this.isConnected = false;
        this.isReconnecting = false;
        this.onConnected = [];
        var httpUrl = (config && config.httpUrl) || HTTP_URL;
        var wsUrl = (config && config.wsUrl) || WS_URL || httpUrl.replace('http', 'ws');
        this.onConnectionStatusChange =
            (config && config.onConnectionStatusChange) || undefined;
        var headers = {};
        var sessionId = config && config.sessionId;
        if (!sessionId &&
            window &&
            window.document &&
            window.document.cookie &&
            typeof window.document.cookie === 'string') {
            window.document.cookie.split(';').forEach(function (entry) {
                if (entry.includes('=')) {
                    var _a = entry.split('='), name_1 = _a[0], value = _a[1];
                    if (name_1.toLowerCase().trim() === 'connect.sid') {
                        sessionId = value.toLowerCase().trim();
                    }
                }
            });
        }
        if (sessionId) {
            headers[SESSION_ID_HEADER] = sessionId;
        }
        var onConnected = this.onConnected;
        // read connect.sid from cookie for WS connects/reconnects
        var readConnectSid = function () {
            try {
                if (typeof window === 'undefined' ||
                    !window.document ||
                    typeof window.document.cookie !== 'string') {
                    return undefined;
                }
                var sid_1;
                window.document.cookie.split(';').forEach(function (entry) {
                    var idx = entry.indexOf('=');
                    if (idx === -1)
                        return;
                    var name = entry.slice(0, idx).trim().toLowerCase();
                    var value = entry.slice(idx + 1).trim();
                    if (name === 'connect.sid')
                        sid_1 = value;
                });
                return sid_1;
            }
            catch (_a) {
                return undefined;
            }
        };
        var wsLink = new subscriptions_1.GraphQLWsLink((0, graphql_ws_1.createClient)({
            url: wsUrl,
            // make session dynamic for WS connects/reconnects
            connectionParams: function () {
                var _a;
                var sid = sessionId || readConnectSid(); // sessionId do config continua tendo prioridade
                return sid ? (_a = {}, _a[SESSION_ID_HEADER] = sid, _a) : {};
            },
            retryAttempts: Infinity,
            shouldRetry: function (event) {
                _this.isReconnecting = true;
                _this.onConnectionStatusChange &&
                    _this.onConnectionStatusChange(_this.isConnected, _this.isReconnecting);
                console.log('ws reconnecting', event);
                return true;
            },
            on: {
                connected: function () {
                    _this.isConnected = true;
                    _this.isReconnecting = false;
                    _this.onConnectionStatusChange &&
                        _this.onConnectionStatusChange(_this.isConnected, _this.isReconnecting);
                    console.log('ws connected');
                    onConnected.forEach(function (fn) { return fn(); });
                },
                error: function (error) {
                    console.error('ws error', {
                        type: error === null || error === void 0 ? void 0 : error.type,
                        isTrusted: error === null || error === void 0 ? void 0 : error.isTrusted,
                        reason: error === null || error === void 0 ? void 0 : error.reason,
                    });
                },
                closed: function (event) {
                    _this.isConnected = false;
                    _this.onConnectionStatusChange &&
                        _this.onConnectionStatusChange(_this.isConnected, _this.isReconnecting);
                    console.error('ws closed', {
                        type: event === null || event === void 0 ? void 0 : event.type,
                        code: event === null || event === void 0 ? void 0 : event.code,
                        reason: event === null || event === void 0 ? void 0 : event.reason,
                        wasClean: event === null || event === void 0 ? void 0 : event.wasClean,
                        isTrusted: event === null || event === void 0 ? void 0 : event.isTrusted,
                    });
                },
            },
        }));
        var httpLink = new core_1.HttpLink({
            uri: httpUrl,
            fetch: cross_fetch_1.default,
            headers: headers,
            credentials: 'include',
        });
        this.apolloClient = new core_1.ApolloClient({
            link: (0, core_1.split)(function (_a) {
                var query = _a.query;
                var definition = (0, utilities_1.getMainDefinition)(query);
                return (definition.kind === 'OperationDefinition' &&
                    definition.operation === 'subscription');
            }, wsLink, httpLink),
            cache: new core_1.InMemoryCache(),
        });
    }
    Back4app2.prototype.tryToExecute = function (fn) {
        return __awaiter(this, void 0, void 0, function () {
            var _loop_1, this_1, i, state_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _loop_1 = function (i) {
                            var _b, e_1, waitSeconds_1;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _c.trys.push([0, 2, , 8]);
                                        _b = {};
                                        return [4 /*yield*/, fn()];
                                    case 1: return [2 /*return*/, (_b.value = _c.sent(), _b)];
                                    case 2:
                                        e_1 = _c.sent();
                                        if (!(e_1 && e_1.message === 'Network request failed')) return [3 /*break*/, 6];
                                        if (!(i < 4)) return [3 /*break*/, 4];
                                        waitSeconds_1 = (i + 1) * 5;
                                        console.error("network request failed (trying again in ".concat(waitSeconds_1, "s)"), e_1);
                                        return [4 /*yield*/, new Promise(function (resolve) {
                                                return setTimeout(resolve, waitSeconds_1 * 1000);
                                            })];
                                    case 3:
                                        _c.sent();
                                        return [3 /*break*/, 5];
                                    case 4:
                                        console.error('network request failed', e_1);
                                        _c.label = 5;
                                    case 5: return [3 /*break*/, 7];
                                    case 6: throw this_1.parseError(e_1);
                                    case 7: return [3 /*break*/, 8];
                                    case 8: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < 5)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1(i)];
                    case 2:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: throw new errors_1.NetworkError();
                }
            });
        });
    };
    Back4app2.prototype.parseError = function (error) {
        var back4app2Error;
        if (error && error.message === 'Network request failed') {
            console.error('network request failed', error);
            return new errors_1.NetworkError();
        }
        else if (error && error.networkError && error.networkError.result) {
            back4app2Error = (0, errors_1.parseBack4app2Error)(error.networkError.result);
        }
        else if (error &&
            error.graphQLErrors &&
            error.graphQLErrors.length === 1 &&
            error.graphQLErrors[0].message &&
            error.graphQLErrors[0].extensions &&
            error.graphQLErrors[0].extensions.code) {
            back4app2Error = (0, errors_1.parseBack4app2Error)({
                message: error.graphQLErrors[0].message,
                code: error.graphQLErrors[0].extensions.code,
            });
        }
        if (back4app2Error) {
            return back4app2Error;
        }
        else {
            console.error('unexpected error', error);
            return new errors_1.UnexpectedError();
        }
    };
    Back4app2.prototype.me = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          query Me {\n            me {\n              id\n              username\n              createdAt\n              disableSolucxForm\n              avatar\n              verification {\n                isCardValidated\n              }\n              maxApps\n            }\n          }\n        "], ["\n          query Me {\n            me {\n              id\n              username\n              createdAt\n              disableSolucxForm\n              avatar\n              verification {\n                isCardValidated\n              }\n              maxApps\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['me']];
                }
            });
        });
    };
    Back4app2.prototype.importGitHubInstallation = function (gitHubCode, gitHubInstallationId) {
        return __awaiter(this, void 0, void 0, function () {
            var parseError, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parseError = this.parseError.bind(this);
                        return [4 /*yield*/, this.tryToExecute(function () {
                                return _this.apolloClient.query({
                                    query: (0, core_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          mutation ImportGitHubInstallation(\n            $gitHubCode: String!\n            $gitHubInstallationId: String!\n          ) {\n            importGitHubInstallation(\n              gitHubCode: $gitHubCode\n              gitHubInstallationId: $gitHubInstallationId\n            ) {\n              id\n              status\n              error {\n                message\n                code\n              }\n            }\n          }\n        "], ["\n          mutation ImportGitHubInstallation(\n            $gitHubCode: String!\n            $gitHubInstallationId: String!\n          ) {\n            importGitHubInstallation(\n              gitHubCode: $gitHubCode\n              gitHubInstallationId: $gitHubInstallationId\n            ) {\n              id\n              status\n              error {\n                message\n                code\n              }\n            }\n          }\n        "]))),
                                    fetchPolicy: 'no-cache',
                                    variables: {
                                        gitHubCode: gitHubCode,
                                        gitHubInstallationId: gitHubInstallationId,
                                    },
                                });
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var subscription = _this.apolloClient
                                    .subscribe({
                                    query: (0, core_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            subscription Task($taskId: String!) {\n              task(id: $taskId) {\n                status\n                error {\n                  message\n                  code\n                }\n              }\n            }\n          "], ["\n            subscription Task($taskId: String!) {\n              task(id: $taskId) {\n                status\n                error {\n                  message\n                  code\n                }\n              }\n            }\n          "]))),
                                    fetchPolicy: 'no-cache',
                                    variables: {
                                        taskId: result &&
                                            result.data &&
                                            result.data['importGitHubInstallation'] &&
                                            result.data['importGitHubInstallation']['id'],
                                    },
                                })
                                    .subscribe({
                                    next: function (value) {
                                        if (value.data['task']['status'] === 'DONE') {
                                            subscription.unsubscribe();
                                            resolve();
                                        }
                                        else if (value.data['task']['status'] === 'FAILED') {
                                            subscription.unsubscribe();
                                            reject((0, errors_1.parseBack4app2Error)(value.data['task']['error'] || new errors_1.UnexpectedError()));
                                        }
                                    },
                                    error: function (error) {
                                        reject(parseError(error));
                                    },
                                });
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Back4app2.prototype.translateGitHubRepositoryFromAPI = function (gitHubRepository) {
        return {
            id: gitHubRepository.id,
            fullName: gitHubRepository.fullName,
            defaultBranch: gitHubRepository.defaultBranch,
            pushedAt: new Date(gitHubRepository.pushedAt),
            projectType: gitHubRepository.projectType,
        };
    };
    Back4app2.prototype.findGitHubRepositories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          query GitHubRepositories {\n            gitHubRepositories {\n              id\n              fullName\n              defaultBranch\n              pushedAt\n              projectType\n            }\n          }\n        "], ["\n          query GitHubRepositories {\n            gitHubRepositories {\n              id\n              fullName\n              defaultBranch\n              pushedAt\n              projectType\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['gitHubRepositories'].map(function (gitHubRepository) {
                                return _this.translateGitHubRepositoryFromAPI(gitHubRepository);
                            })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToGitHubRepositories = function (callback) {
        var _this = this;
        var findGitHubRepositories = this.findGitHubRepositories.bind(this);
        var translateGitHubRepositoryFromAPI = this.translateGitHubRepositoryFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var gitHubRepositories;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          subscription GitHubRepositoryEvents {\n            gitHubRepositoryEvents {\n              kind\n              id\n              object {\n                id\n                fullName\n                defaultBranch\n                pushedAt\n                projectType\n              }\n            }\n          }\n        "], ["\n          subscription GitHubRepositoryEvents {\n            gitHubRepositoryEvents {\n              kind\n              id\n              object {\n                id\n                fullName\n                defaultBranch\n                pushedAt\n                projectType\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['gitHubRepositoryEvents']['kind']) {
                    case 'INSERT':
                    case 'UPDATE':
                    case 'ENTER':
                        removeObject(value.data['gitHubRepositoryEvents']['id']);
                        insertObject(translateGitHubRepositoryFromAPI(value.data['gitHubRepositoryEvents']['object']));
                        break;
                    case 'LEAVE':
                    case 'DELETE':
                        removeObject(value.data['gitHubRepositoryEvents']['id']);
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, gitHubRepositories);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findGitHubRepositories()];
                    case 1:
                        gitHubRepositories = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        if (!(e_2 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_2, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, gitHubRepositories);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < gitHubRepositories.length; i++) {
                if (gitHubRepositories[i].pushedAt <= object['pushedAt']) {
                    break;
                }
            }
            gitHubRepositories = __spreadArray(__spreadArray(__spreadArray([], gitHubRepositories.slice(0, i), true), [
                object
            ], false), gitHubRepositories.slice(i), true);
        };
        var removeObject = function (id) {
            var object = gitHubRepositories.find(function (object) { return object.id === id; });
            if (object) {
                gitHubRepositories.splice(gitHubRepositories.indexOf(object), 1);
            }
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.translateTaskFromAPI = function (task) {
        return {
            id: task.id,
            status: task.status,
            createdAt: new Date(task.createdAt),
            startedAt: (task.startedAt && new Date(task.startedAt)) || undefined,
            finishedAt: (task.finishedAt && new Date(task.finishedAt)) || undefined,
            elapsedTimeMS: task.elapsedTimeMS,
        };
    };
    Back4app2.prototype.translateDeploymentFromAPI = function (deployment) {
        return {
            id: deployment.id,
            branchName: deployment.branchName,
            deployTask: (deployment.deployTask &&
                this.translateTaskFromAPI(deployment.deployTask)) ||
                undefined,
            commitSHA: deployment.commitSHA,
            commitMessage: deployment.commitMessage,
            commitAuthorLogin: deployment.commitAuthorLogin,
            commitCommitterLogin: deployment.commitCommitterLogin,
            committedAt: (deployment.committedAt && new Date(deployment.committedAt)) ||
                undefined,
            status: deployment.status,
            createdAt: new Date(deployment.createdAt),
            lastDockerfileChat: deployment.lastDockerfileChat,
            error: deployment.error
                ? (0, errors_1.parseBack4app2Error)(deployment.error)
                : undefined,
        };
    };
    Back4app2.prototype.translateCustomDomainFromAPI = function (customDomain) {
        return __assign(__assign({}, customDomain), { error: customDomain.error
                ? (0, errors_1.parseBack4app2Error)(customDomain.error)
                : undefined });
    };
    Back4app2.prototype.translateAppFromAPI = function (app) {
        var _a;
        var mainServiceEnvironment = app && app.mainService && app.mainService.mainServiceEnvironment;
        if (mainServiceEnvironment === null || mainServiceEnvironment === void 0 ? void 0 : mainServiceEnvironment.lastDeployment) {
            mainServiceEnvironment.lastDeployment = this.translateDeploymentFromAPI(mainServiceEnvironment.lastDeployment);
        }
        if (mainServiceEnvironment === null || mainServiceEnvironment === void 0 ? void 0 : mainServiceEnvironment.activeDeployment) {
            mainServiceEnvironment.activeDeployment = this.translateDeploymentFromAPI(mainServiceEnvironment.activeDeployment);
        }
        // isOwner and collabAccess are already in the API response, just pass them through
        return __assign(__assign({}, app), { isOwner: (_a = app.isOwner) !== null && _a !== void 0 ? _a : false, collabAccess: app.collabAccess || undefined });
    };
    Back4app2.prototype.createAppFromRepository = function (name, repositoryId, branchName, rootDirPath, autoDeploy, envVars, healthCheckEndpoint, exposedPort, maxApps) {
        return __awaiter(this, void 0, void 0, function () {
            var parseError, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parseError = this.parseError.bind(this);
                        return [4 /*yield*/, this.tryToExecute(function () {
                                return _this.apolloClient.query({
                                    query: (0, core_1.gql)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          mutation CreateAppFromRepository(\n            $name: String!\n            $repositoryId: String!\n            $branchName: String!\n            $rootDirPath: String!\n            $autoDeploy: Boolean!\n            $envVars: [EnvVarInput!]!\n            $healthCheckEndpoint: String!\n            $exposedPort: Int\n            $maxApps: Int\n          ) {\n            createAppFromRepository(\n              name: $name\n              repositoryId: $repositoryId\n              branchName: $branchName\n              rootDirPath: $rootDirPath\n              autoDeploy: $autoDeploy\n              envVars: $envVars\n              healthCheckEndpoint: $healthCheckEndpoint\n              exposedPort: $exposedPort\n              maxApps: $maxApps\n            ) {\n              id\n              status\n              result\n              error {\n                message\n                code\n              }\n            }\n          }\n        "], ["\n          mutation CreateAppFromRepository(\n            $name: String!\n            $repositoryId: String!\n            $branchName: String!\n            $rootDirPath: String!\n            $autoDeploy: Boolean!\n            $envVars: [EnvVarInput!]!\n            $healthCheckEndpoint: String!\n            $exposedPort: Int\n            $maxApps: Int\n          ) {\n            createAppFromRepository(\n              name: $name\n              repositoryId: $repositoryId\n              branchName: $branchName\n              rootDirPath: $rootDirPath\n              autoDeploy: $autoDeploy\n              envVars: $envVars\n              healthCheckEndpoint: $healthCheckEndpoint\n              exposedPort: $exposedPort\n              maxApps: $maxApps\n            ) {\n              id\n              status\n              result\n              error {\n                message\n                code\n              }\n            }\n          }\n        "]))),
                                    fetchPolicy: 'no-cache',
                                    variables: {
                                        name: name,
                                        repositoryId: repositoryId,
                                        branchName: branchName,
                                        rootDirPath: rootDirPath,
                                        autoDeploy: autoDeploy,
                                        envVars: envVars,
                                        healthCheckEndpoint: healthCheckEndpoint,
                                        exposedPort: exposedPort,
                                        maxApps: maxApps,
                                    },
                                });
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var subscription = _this.apolloClient
                                    .subscribe({
                                    query: (0, core_1.gql)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            subscription Task($taskId: String!) {\n              task(id: $taskId) {\n                status\n                result\n                error {\n                  message\n                  code\n                }\n              }\n            }\n          "], ["\n            subscription Task($taskId: String!) {\n              task(id: $taskId) {\n                status\n                result\n                error {\n                  message\n                  code\n                }\n              }\n            }\n          "]))),
                                    fetchPolicy: 'no-cache',
                                    variables: {
                                        taskId: result &&
                                            result.data &&
                                            result.data['createAppFromRepository'] &&
                                            result.data['createAppFromRepository']['id'],
                                    },
                                })
                                    .subscribe({
                                    next: function (value) {
                                        if (value.data['task']['status'] === 'DONE') {
                                            subscription.unsubscribe();
                                            resolve(JSON.parse(value.data['task']['result']));
                                        }
                                        else if (value.data['task']['status'] === 'FAILED') {
                                            subscription.unsubscribe();
                                            reject((0, errors_1.parseBack4app2Error)(value.data['task']['error'] || new errors_1.UnexpectedError()));
                                        }
                                    },
                                    error: function (error) {
                                        reject(parseError(error));
                                    },
                                });
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Back4app2.prototype.updateAppSettings = function (appId, branchName, rootDirPath, autoDeploy, envVars, healthCheckEndpoint, exposedPort) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          mutation updateAppSettings(\n            $appId: String!\n            $branchName: String\n            $rootDirPath: String\n            $autoDeploy: Boolean\n            $envVars: [EnvVarInput!]\n            $healthCheckEndpoint: String\n            $exposedPort: Int\n          ) {\n            updateAppSettings(\n              appId: $appId\n              branchName: $branchName\n              rootDirPath: $rootDirPath\n              autoDeploy: $autoDeploy\n              envVars: $envVars\n              healthCheckEndpoint: $healthCheckEndpoint\n              exposedPort: $exposedPort\n            ) {\n              id\n              status\n              name\n              isOwner\n              collabAccess {\n                isPending\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n              }\n              mainService {\n                mainServiceEnvironment {\n                  id\n                  branchName\n                  mainCustomDomain {\n                    id\n                    name\n                    cname\n                    redirectTo {\n                      id\n                      name\n                    }\n                    status\n                    error {\n                      code\n                      message\n                    }\n                  }\n                  rootDirPath\n                  autoDeploy\n                  envVars {\n                    key\n                    value\n                  }\n                  plan {\n                    id\n                    name\n                    maxRAM\n                    maxCPU\n                  }\n                  isPendingPayment\n                  isFreePlanElegible\n                  healthCheckEndpoint\n                  exposedPort\n                }\n              }\n            }\n          }\n        "], ["\n          mutation updateAppSettings(\n            $appId: String!\n            $branchName: String\n            $rootDirPath: String\n            $autoDeploy: Boolean\n            $envVars: [EnvVarInput!]\n            $healthCheckEndpoint: String\n            $exposedPort: Int\n          ) {\n            updateAppSettings(\n              appId: $appId\n              branchName: $branchName\n              rootDirPath: $rootDirPath\n              autoDeploy: $autoDeploy\n              envVars: $envVars\n              healthCheckEndpoint: $healthCheckEndpoint\n              exposedPort: $exposedPort\n            ) {\n              id\n              status\n              name\n              isOwner\n              collabAccess {\n                isPending\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n              }\n              mainService {\n                mainServiceEnvironment {\n                  id\n                  branchName\n                  mainCustomDomain {\n                    id\n                    name\n                    cname\n                    redirectTo {\n                      id\n                      name\n                    }\n                    status\n                    error {\n                      code\n                      message\n                    }\n                  }\n                  rootDirPath\n                  autoDeploy\n                  envVars {\n                    key\n                    value\n                  }\n                  plan {\n                    id\n                    name\n                    maxRAM\n                    maxCPU\n                  }\n                  isPendingPayment\n                  isFreePlanElegible\n                  healthCheckEndpoint\n                  exposedPort\n                }\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                    branchName: branchName,
                                    rootDirPath: rootDirPath,
                                    autoDeploy: autoDeploy,
                                    envVars: envVars,
                                    healthCheckEndpoint: healthCheckEndpoint,
                                    exposedPort: exposedPort,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.translateAppFromAPI(result.data['updateAppSettings'])];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToApp = function (id, callback) {
        var _this = this;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n          subscription App($id: String!) {\n            app(id: $id) {\n              id\n              name\n              isOwner\n              collabAccess {\n                isPending\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n              }\n              mainService {\n                id\n                name\n                repository {\n                  id\n                  fullName\n                  defaultBranch\n                  pushedAt\n                  projectType\n                }\n                mainServiceEnvironment {\n                  id\n                  environment {\n                    id\n                    name\n                  }\n                  branchName\n                  mainCustomDomain {\n                    id\n                    name\n                    cname\n                    redirectTo {\n                      id\n                      name\n                    }\n                    status\n                    error {\n                      code\n                      message\n                    }\n                  }\n                  rootDirPath\n                  autoDeploy\n                  envVars {\n                    key\n                    value\n                  }\n                  plan {\n                    id\n                    name\n                    maxCPU\n                    maxRAM\n                  }\n                  isPendingPayment\n                  isFreePlanElegible\n                  lastDeployment {\n                    id\n                    branchName\n                    deployTask {\n                      id\n                      status\n                      createdAt\n                      startedAt\n                      finishedAt\n                      elapsedTimeMS\n                    }\n                    commitSHA\n                    commitMessage\n                    commitAuthorLogin\n                    commitCommitterLogin\n                    committedAt\n                    status\n                    createdAt\n                    error {\n                      code\n                      message\n                    }\n                    lastDockerfileChat {\n                      id\n                    }\n                  }\n                  activeDeployment {\n                    id\n                    branchName\n                    deployTask {\n                      id\n                      status\n                      createdAt\n                      startedAt\n                      finishedAt\n                      elapsedTimeMS\n                    }\n                    commitSHA\n                    commitMessage\n                    commitAuthorLogin\n                    commitCommitterLogin\n                    committedAt\n                    status\n                    createdAt\n                  }\n                }\n              }\n              status\n              error {\n                message\n                code\n              }\n            }\n          }\n        "], ["\n          subscription App($id: String!) {\n            app(id: $id) {\n              id\n              name\n              isOwner\n              collabAccess {\n                isPending\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n              }\n              mainService {\n                id\n                name\n                repository {\n                  id\n                  fullName\n                  defaultBranch\n                  pushedAt\n                  projectType\n                }\n                mainServiceEnvironment {\n                  id\n                  environment {\n                    id\n                    name\n                  }\n                  branchName\n                  mainCustomDomain {\n                    id\n                    name\n                    cname\n                    redirectTo {\n                      id\n                      name\n                    }\n                    status\n                    error {\n                      code\n                      message\n                    }\n                  }\n                  rootDirPath\n                  autoDeploy\n                  envVars {\n                    key\n                    value\n                  }\n                  plan {\n                    id\n                    name\n                    maxCPU\n                    maxRAM\n                  }\n                  isPendingPayment\n                  isFreePlanElegible\n                  lastDeployment {\n                    id\n                    branchName\n                    deployTask {\n                      id\n                      status\n                      createdAt\n                      startedAt\n                      finishedAt\n                      elapsedTimeMS\n                    }\n                    commitSHA\n                    commitMessage\n                    commitAuthorLogin\n                    commitCommitterLogin\n                    committedAt\n                    status\n                    createdAt\n                    error {\n                      code\n                      message\n                    }\n                    lastDockerfileChat {\n                      id\n                    }\n                  }\n                  activeDeployment {\n                    id\n                    branchName\n                    deployTask {\n                      id\n                      status\n                      createdAt\n                      startedAt\n                      finishedAt\n                      elapsedTimeMS\n                    }\n                    commitSHA\n                    commitMessage\n                    commitAuthorLogin\n                    commitCommitterLogin\n                    committedAt\n                    status\n                    createdAt\n                  }\n                }\n              }\n              status\n              error {\n                message\n                code\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                id: id,
            },
        })
            .subscribe({
            next: function (value) {
                callback(null, _this.translateAppFromAPI(value.data['app']));
            },
            error: function (error) {
                callback(_this.parseError(error));
            },
        });
        return {
            unsubscribe: function () {
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.findApps = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n          query Apps {\n            apps {\n              id\n              name\n              isFavourite\n              isOwner\n              collabAccess {\n                isPending\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n              }\n              mainService {\n                mainServiceEnvironment {\n                  mainCustomDomain {\n                    id\n                    name\n                    cname\n                    redirectTo {\n                      id\n                      name\n                    }\n                    status\n                    error {\n                      code\n                      message\n                    }\n                  }\n                  plan {\n                    name\n                  }\n                  isPendingPayment\n                  isFreePlanElegible\n                  lastDeployment {\n                    id\n                    branchName\n                    deployTask {\n                      status\n                    }\n                    status\n                    lastDockerfileChat {\n                      id\n                    }\n                  }\n                  activeDeployment {\n                    id\n                    branchName\n                    deployTask {\n                      status\n                    }\n                  }\n                }\n              }\n              status\n            }\n          }\n        "], ["\n          query Apps {\n            apps {\n              id\n              name\n              isFavourite\n              isOwner\n              collabAccess {\n                isPending\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n              }\n              mainService {\n                mainServiceEnvironment {\n                  mainCustomDomain {\n                    id\n                    name\n                    cname\n                    redirectTo {\n                      id\n                      name\n                    }\n                    status\n                    error {\n                      code\n                      message\n                    }\n                  }\n                  plan {\n                    name\n                  }\n                  isPendingPayment\n                  isFreePlanElegible\n                  lastDeployment {\n                    id\n                    branchName\n                    deployTask {\n                      status\n                    }\n                    status\n                    lastDockerfileChat {\n                      id\n                    }\n                  }\n                  activeDeployment {\n                    id\n                    branchName\n                    deployTask {\n                      status\n                    }\n                  }\n                }\n              }\n              status\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['apps'].map(function (app) { return _this.translateAppFromAPI(app); })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToApps = function (callback) {
        var _this = this;
        var findApps = this.findApps.bind(this);
        var translateAppFromAPI = this.translateAppFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var apps;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n          subscription AppEvents {\n            appEvents {\n              kind\n              id\n              object {\n                id\n                name\n                isFavourite\n                isOwner\n                collabAccess {\n                  isPending\n                  containersPermission {\n                    Overview\n                    Logs\n                    Deployments\n                    Metrics\n                    Settings {\n                      General\n                      BuildAndDeploy\n                      EnvVars\n                      Domain\n                      HealthAndAlert\n                    }\n                    Actions {\n                      Deploy\n                    }\n                  }\n                }\n                mainService {\n                  mainServiceEnvironment {\n                    mainCustomDomain {\n                      id\n                      name\n                      cname\n                      redirectTo {\n                        id\n                        name\n                      }\n                      status\n                      error {\n                        code\n                        message\n                      }\n                    }\n                    plan {\n                      name\n                    }\n                    isPendingPayment\n                    isFreePlanElegible\n                    lastDeployment {\n                      id\n                      branchName\n                      deployTask {\n                        status\n                      }\n                      status\n                      lastDockerfileChat {\n                        id\n                      }\n                    }\n                    activeDeployment {\n                      id\n                      branchName\n                      deployTask {\n                        status\n                      }\n                    }\n                  }\n                }\n                status\n              }\n            }\n          }\n        "], ["\n          subscription AppEvents {\n            appEvents {\n              kind\n              id\n              object {\n                id\n                name\n                isFavourite\n                isOwner\n                collabAccess {\n                  isPending\n                  containersPermission {\n                    Overview\n                    Logs\n                    Deployments\n                    Metrics\n                    Settings {\n                      General\n                      BuildAndDeploy\n                      EnvVars\n                      Domain\n                      HealthAndAlert\n                    }\n                    Actions {\n                      Deploy\n                    }\n                  }\n                }\n                mainService {\n                  mainServiceEnvironment {\n                    mainCustomDomain {\n                      id\n                      name\n                      cname\n                      redirectTo {\n                        id\n                        name\n                      }\n                      status\n                      error {\n                        code\n                        message\n                      }\n                    }\n                    plan {\n                      name\n                    }\n                    isPendingPayment\n                    isFreePlanElegible\n                    lastDeployment {\n                      id\n                      branchName\n                      deployTask {\n                        status\n                      }\n                      status\n                      lastDockerfileChat {\n                        id\n                      }\n                    }\n                    activeDeployment {\n                      id\n                      branchName\n                      deployTask {\n                        status\n                      }\n                    }\n                  }\n                }\n                status\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['appEvents']['kind']) {
                    case 'INSERT':
                    case 'UPDATE':
                    case 'ENTER':
                        removeObject(value.data['appEvents']['id']);
                        insertObject(translateAppFromAPI(value.data['appEvents']['object']));
                        break;
                    case 'LEAVE':
                    case 'DELETE':
                        removeObject(value.data['appEvents']['id']);
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, apps);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findApps()];
                    case 1:
                        apps = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        if (!(e_3 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_3, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, apps);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < apps.length; i++) {
                if (apps[i].name <= object['name']) {
                    break;
                }
            }
            apps = __spreadArray(__spreadArray(__spreadArray([], apps.slice(0, i), true), [object], false), apps.slice(i), true);
        };
        var removeObject = function (id) {
            var object = apps.find(function (object) { return object.id === id; });
            if (object) {
                apps.splice(apps.indexOf(object), 1);
            }
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.createCustomDomain = function (serviceEnvironmentId, name, redirectToId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n          mutation CreateCustomDomain(\n            $serviceEnvironmentId: String!\n            $name: String!\n            $redirectToId: String\n          ) {\n            createCustomDomain(\n              serviceEnvironmentId: $serviceEnvironmentId\n              name: $name\n              redirectToId: $redirectToId\n            ) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "], ["\n          mutation CreateCustomDomain(\n            $serviceEnvironmentId: String!\n            $name: String!\n            $redirectToId: String\n          ) {\n            createCustomDomain(\n              serviceEnvironmentId: $serviceEnvironmentId\n              name: $name\n              redirectToId: $redirectToId\n            ) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    serviceEnvironmentId: serviceEnvironmentId,
                                    name: name,
                                    redirectToId: redirectToId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['createCustomDomain']];
                }
            });
        });
    };
    Back4app2.prototype.updateCustomDomain = function (customDomainId, redirectToId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n          mutation UpdateCustomDomain(\n            $customDomainId: String!\n            $redirectToId: String\n          ) {\n            updateCustomDomain(\n              customDomainId: $customDomainId\n              redirectToId: $redirectToId\n            ) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "], ["\n          mutation UpdateCustomDomain(\n            $customDomainId: String!\n            $redirectToId: String\n          ) {\n            updateCustomDomain(\n              customDomainId: $customDomainId\n              redirectToId: $redirectToId\n            ) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    customDomainId: customDomainId,
                                    redirectToId: redirectToId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['updateCustomDomain']];
                }
            });
        });
    };
    Back4app2.prototype.deleteCustomDomain = function (customDomainId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n          mutation DeleteCustomDomain($customDomainId: String!) {\n            deleteCustomDomain(customDomainId: $customDomainId) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "], ["\n          mutation DeleteCustomDomain($customDomainId: String!) {\n            deleteCustomDomain(customDomainId: $customDomainId) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    customDomainId: customDomainId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['deleteCustomDomain']];
                }
            });
        });
    };
    Back4app2.prototype.verifyCustomDomainDNS = function (customDomainId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n          mutation VerifyCustomDomainDNS($customDomainId: String!) {\n            verifyCustomDomainDNS(customDomainId: $customDomainId) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "], ["\n          mutation VerifyCustomDomainDNS($customDomainId: String!) {\n            verifyCustomDomainDNS(customDomainId: $customDomainId) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    customDomainId: customDomainId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['verifyCustomDomainDNS']];
                }
            });
        });
    };
    Back4app2.prototype.findCustomDomains = function (serviceEnvironmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n          query CustomDomains($serviceEnvironmentId: String!) {\n            customDomains(serviceEnvironmentId: $serviceEnvironmentId) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "], ["\n          query CustomDomains($serviceEnvironmentId: String!) {\n            customDomains(serviceEnvironmentId: $serviceEnvironmentId) {\n              id\n              name\n              cname\n              redirectTo {\n                id\n                name\n              }\n              status\n              error {\n                code\n                message\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    serviceEnvironmentId: serviceEnvironmentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['customDomains'].map(function (customDomain) {
                                return _this.translateCustomDomainFromAPI(customDomain);
                            })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToCustomDomains = function (serviceEnvironmentId, callback) {
        var _this = this;
        var findCustomDomains = this.findCustomDomains.bind(this);
        var parseError = this.parseError.bind(this);
        var customDomains;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n          subscription CustomDomainEvents($serviceEnvironmentId: String!) {\n            customDomainEvents(serviceEnvironmentId: $serviceEnvironmentId) {\n              kind\n              id\n              object {\n                id\n                name\n                cname\n                redirectTo {\n                  id\n                  name\n                }\n                status\n                error {\n                  code\n                  message\n                }\n              }\n            }\n          }\n        "], ["\n          subscription CustomDomainEvents($serviceEnvironmentId: String!) {\n            customDomainEvents(serviceEnvironmentId: $serviceEnvironmentId) {\n              kind\n              id\n              object {\n                id\n                name\n                cname\n                redirectTo {\n                  id\n                  name\n                }\n                status\n                error {\n                  code\n                  message\n                }\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                serviceEnvironmentId: serviceEnvironmentId,
            },
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['customDomainEvents']['kind']) {
                    case 'INSERT':
                        insertObject(value.data['customDomainEvents']['object']);
                        break;
                    case 'UPDATE':
                        removeObject(value.data['customDomainEvents']['id']);
                        insertObject(value.data['customDomainEvents']['object']);
                        break;
                    case 'DELETE':
                        deleteObject(value.data['customDomainEvents']['id']);
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, customDomains);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findCustomDomains(serviceEnvironmentId)];
                    case 1:
                        customDomains = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _a.sent();
                        if (!(e_4 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_4, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, customDomains);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < customDomains.length; i++) {
                if (customDomains[i].id === object['id']) {
                    break;
                }
            }
            customDomains = __spreadArray(__spreadArray(__spreadArray([], customDomains.slice(0, i), true), [
                object
            ], false), customDomains.slice(i), true);
        };
        var removeObject = function (id) {
            var object = customDomains.find(function (object) { return object.id === id; });
            if (object) {
                customDomains.splice(customDomains.indexOf(object), 1);
            }
        };
        var deleteObject = function (id) {
            var index = customDomains.findIndex(function (customDomain) { return customDomain.id === id; });
            if (index >= 0) {
                customDomains = __spreadArray(__spreadArray([], customDomains.slice(0, index), true), customDomains.slice(index + 1), true);
            }
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.findAppsPlans = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n          query AppsPlans {\n            appsPlans {\n              status\n            }\n          }\n        "], ["\n          query AppsPlans {\n            appsPlans {\n              status\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['appsPlans']];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToFreePlanUsageHours = function (callback) {
        var _this = this;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n          subscription FreePlanUsageHours {\n            freePlanUsageHours\n          }\n        "], ["\n          subscription FreePlanUsageHours {\n            freePlanUsageHours\n          }\n        "]))),
            fetchPolicy: 'no-cache',
        })
            .subscribe({
            next: function (value) {
                callback(null, value.data['freePlanUsageHours']);
            },
            error: function (error) {
                callback(_this.parseError(error));
            },
        });
        return {
            unsubscribe: function () {
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.translateDeploymentLogFromAPI = function (deploymentLog) {
        return {
            id: deploymentLog.id,
            time: new Date(deploymentLog.time),
            message: deploymentLog.message,
            level: deploymentLog.level,
        };
    };
    Back4app2.prototype.translateChatMessageFromAPI = function (chatMessage) {
        var _a;
        return {
            id: chatMessage.id,
            question: chatMessage.question,
            askedAt: new Date(chatMessage.askedAt),
            aiPrompt: chatMessage.aiPrompt || '',
            aiResponse: chatMessage.aiResponse,
            respondedAt: chatMessage.respondedAt
                ? new Date(chatMessage.respondedAt)
                : undefined,
            error: chatMessage.error
                ? (0, errors_1.parseBack4app2Error)(chatMessage.error)
                : undefined,
            status: chatMessage.status,
            attachments: (_a = chatMessage.attachments) === null || _a === void 0 ? void 0 : _a.map(function (attachment) { return ({
                id: attachment.id,
                fileName: attachment.fileName,
                mimeType: attachment.mimeType,
                sizeBytes: attachment.sizeBytes,
                status: attachment.status,
                presignedUrl: attachment.presignedUrl,
            }); }),
        };
    };
    Back4app2.prototype.translateAgentFromAPI = function (agent) {
        return {
            id: agent.id,
            name: agent.name,
            status: agent.status,
            mainChat: agent.mainChat,
            currentAppId: agent.currentAppId,
            currentAppName: agent.currentAppName,
            currentPreviewWebHostingURL: agent.currentPreviewWebHostingURL,
            currentAppDashboardURL: agent.currentAppDashboardURL,
            currentPublicWebHostingURL: agent.currentPublicWebHostingURL,
            createdAt: new Date(agent.createdAt),
        };
    };
    Back4app2.prototype.findDeploymentLogs = function (deploymentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n          query DeploymentLogs($deploymentId: String!) {\n            deploymentLogs(deploymentId: $deploymentId) {\n              id\n              time\n              message\n              level\n            }\n          }\n        "], ["\n          query DeploymentLogs($deploymentId: String!) {\n            deploymentLogs(deploymentId: $deploymentId) {\n              id\n              time\n              message\n              level\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    deploymentId: deploymentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['deploymentLogs'].map(function (deploymentLog) {
                                return _this.translateDeploymentLogFromAPI(deploymentLog);
                            })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToDeploymentLogs = function (deploymentId, callback) {
        var _this = this;
        var findDeploymentLogs = this.findDeploymentLogs.bind(this);
        var translateDeploymentLogFromAPI = this.translateDeploymentLogFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var deploymentLogs = [];
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n          subscription DeploymentLogEvents($deploymentId: String!) {\n            deploymentLogEvents(deploymentId: $deploymentId) {\n              kind\n              id\n              object {\n                id\n                time\n                message\n                level\n              }\n            }\n          }\n        "], ["\n          subscription DeploymentLogEvents($deploymentId: String!) {\n            deploymentLogEvents(deploymentId: $deploymentId) {\n              kind\n              id\n              object {\n                id\n                time\n                message\n                level\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                deploymentId: deploymentId,
            },
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['deploymentLogEvents']['kind']) {
                    case 'INSERT':
                        insertObject(translateDeploymentLogFromAPI(value.data['deploymentLogEvents']['object']));
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, deploymentLogs);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findDeploymentLogs(deploymentId)];
                    case 1:
                        deploymentLogs = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        if (!(e_5 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_5, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, deploymentLogs);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < deploymentLogs.length; i++) {
                if (deploymentLogs[i].time > object['time']) {
                    break;
                }
            }
            deploymentLogs = __spreadArray(__spreadArray(__spreadArray([], deploymentLogs.slice(0, i), true), [
                object
            ], false), deploymentLogs.slice(i), true);
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.findAppById = function (appId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n          query App($appId: String!) {\n            app(appId: $appId) {\n              id\n              name\n              status\n              isOwner\n              collabAccess {\n                isPending\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n              }\n              mainService {\n                mainServiceEnvironment {\n                  id\n                  branchName\n                  mainCustomDomain {\n                    id\n                    name\n                  }\n                  rootDirPath\n                  autoDeploy\n                  envVars {\n                    key\n                    value\n                  }\n                  plan {\n                    id\n                    name\n                    maxRAM\n                    maxCPU\n                    price\n                    tagline\n                  }\n                  isPendingPayment\n                  isFreePlanElegible\n                  healthCheckEndpoint\n                  exposedPort\n                }\n              }\n            }\n          }\n        "], ["\n          query App($appId: String!) {\n            app(appId: $appId) {\n              id\n              name\n              status\n              isOwner\n              collabAccess {\n                isPending\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n              }\n              mainService {\n                mainServiceEnvironment {\n                  id\n                  branchName\n                  mainCustomDomain {\n                    id\n                    name\n                  }\n                  rootDirPath\n                  autoDeploy\n                  envVars {\n                    key\n                    value\n                  }\n                  plan {\n                    id\n                    name\n                    maxRAM\n                    maxCPU\n                    price\n                    tagline\n                  }\n                  isPendingPayment\n                  isFreePlanElegible\n                  healthCheckEndpoint\n                  exposedPort\n                }\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['app']];
                }
            });
        });
    };
    Back4app2.prototype.translateContainerLogFromAPI = function (containerLog) {
        return {
            id: containerLog.id,
            container: containerLog.container,
            deployment: containerLog.deployment,
            source: containerLog.source,
            time: new Date(containerLog.time),
            message: containerLog.message,
        };
    };
    Back4app2.prototype.findContainersLogs = function (serviceEnvironmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n          query ContainersLogs($serviceEnvironmentId: String!) {\n            containersLogs(serviceEnvironmentId: $serviceEnvironmentId) {\n              id\n              container {\n                id\n              }\n              deployment {\n                id\n              }\n              source\n              time\n              message\n            }\n          }\n        "], ["\n          query ContainersLogs($serviceEnvironmentId: String!) {\n            containersLogs(serviceEnvironmentId: $serviceEnvironmentId) {\n              id\n              container {\n                id\n              }\n              deployment {\n                id\n              }\n              source\n              time\n              message\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    serviceEnvironmentId: serviceEnvironmentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['containersLogs'].map(function (containerLog) {
                                return _this.translateContainerLogFromAPI(containerLog);
                            })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToContainersLogs = function (serviceEnvironmentId, callback) {
        var _this = this;
        var findContainersLogs = this.findContainersLogs.bind(this);
        var translateContainerLogFromAPI = this.translateContainerLogFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var containersLogs;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n          subscription ContainerLogEvents($serviceEnvironmentId: String!) {\n            containerLogEvents(serviceEnvironmentId: $serviceEnvironmentId) {\n              kind\n              id\n              object {\n                id\n                container {\n                  id\n                }\n                deployment {\n                  id\n                }\n                source\n                time\n                message\n              }\n            }\n          }\n        "], ["\n          subscription ContainerLogEvents($serviceEnvironmentId: String!) {\n            containerLogEvents(serviceEnvironmentId: $serviceEnvironmentId) {\n              kind\n              id\n              object {\n                id\n                container {\n                  id\n                }\n                deployment {\n                  id\n                }\n                source\n                time\n                message\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                serviceEnvironmentId: serviceEnvironmentId,
            },
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['containerLogEvents']['kind']) {
                    case 'INSERT':
                        insertObject(translateContainerLogFromAPI(value.data['containerLogEvents']['object']));
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, containersLogs);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findContainersLogs(serviceEnvironmentId)];
                    case 1:
                        containersLogs = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_6 = _a.sent();
                        if (!(e_6 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_6, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, containersLogs);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < containersLogs.length; i++) {
                if (containersLogs[i].time > object['time']) {
                    break;
                }
            }
            containersLogs = __spreadArray(__spreadArray(__spreadArray([], containersLogs.slice(0, i), true), [
                object
            ], false), containersLogs.slice(i), true);
            if (containersLogs.length > 100) {
                containersLogs = containersLogs.slice(containersLogs.length - 100);
            }
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.translateContainerDiskSizeFromAPI = function (containerDiskSize) {
        return {
            id: containerDiskSize.id,
            container: containerDiskSize.container,
            deployment: containerDiskSize.deployment,
            time: new Date(containerDiskSize.time),
            rootSize: containerDiskSize.rootSize,
            containerSize: containerDiskSize.containerSize,
            size: containerDiskSize.size,
        };
    };
    Back4app2.prototype.findContainersDisksSizes = function (serviceEnvironmentId, from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n          query ContainersDisksSizes(\n            $serviceEnvironmentId: String!\n            $from: Date!\n            $to: Date\n          ) {\n            containersDisksSizes(\n              serviceEnvironmentId: $serviceEnvironmentId\n              from: $from\n              to: $to\n            ) {\n              id\n              container {\n                id\n                maxCPU\n                maxRAM\n                maxPID\n                maxDiskSize\n              }\n              deployment {\n                id\n              }\n              time\n              rootSize\n              containerSize\n              size\n            }\n          }\n        "], ["\n          query ContainersDisksSizes(\n            $serviceEnvironmentId: String!\n            $from: Date!\n            $to: Date\n          ) {\n            containersDisksSizes(\n              serviceEnvironmentId: $serviceEnvironmentId\n              from: $from\n              to: $to\n            ) {\n              id\n              container {\n                id\n                maxCPU\n                maxRAM\n                maxPID\n                maxDiskSize\n              }\n              deployment {\n                id\n              }\n              time\n              rootSize\n              containerSize\n              size\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    serviceEnvironmentId: serviceEnvironmentId,
                                    from: (from && from.toISOString()) || undefined,
                                    to: (to && to.toISOString()) || undefined,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['containersDisksSizes'].map(function (containerDiskSize) {
                                return _this.translateContainerDiskSizeFromAPI(containerDiskSize);
                            })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToContainersDisksSizes = function (serviceEnvironmentId, timeWindow, callback) {
        var _this = this;
        var sixHoursInMS = 6 * 60 * 60 * 1000;
        if (timeWindow > sixHoursInMS) {
            throw new errors_1.InvalidInputError('The time window cannot be bigger than 6h');
        }
        var findContainersDisksSizes = this.findContainersDisksSizes.bind(this);
        var translateContainerDiskSizeFromAPI = this.translateContainerDiskSizeFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var containersDisksSizes;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n          subscription ContainerDiskSizeEvents($serviceEnvironmentId: String!) {\n            containerDiskSizeEvents(\n              serviceEnvironmentId: $serviceEnvironmentId\n            ) {\n              kind\n              id\n              object {\n                id\n                container {\n                  id\n                  maxCPU\n                  maxRAM\n                  maxPID\n                  maxDiskSize\n                }\n                deployment {\n                  id\n                }\n                time\n                rootSize\n                containerSize\n                size\n              }\n            }\n          }\n        "], ["\n          subscription ContainerDiskSizeEvents($serviceEnvironmentId: String!) {\n            containerDiskSizeEvents(\n              serviceEnvironmentId: $serviceEnvironmentId\n            ) {\n              kind\n              id\n              object {\n                id\n                container {\n                  id\n                  maxCPU\n                  maxRAM\n                  maxPID\n                  maxDiskSize\n                }\n                deployment {\n                  id\n                }\n                time\n                rootSize\n                containerSize\n                size\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                serviceEnvironmentId: serviceEnvironmentId,
            },
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['containerDiskSizeEvents']['kind']) {
                    case 'INSERT':
                        insertObject(translateContainerDiskSizeFromAPI(value.data['containerDiskSizeEvents']['object']));
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, containersDisksSizes);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_7, sixHoursAgo, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findContainersDisksSizes(serviceEnvironmentId, timeWindow === sixHoursInMS
                                ? undefined
                                : new Date(new Date().getTime() - timeWindow))];
                    case 1:
                        containersDisksSizes = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_7 = _a.sent();
                        if (!(e_7 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_7, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        sixHoursAgo = new Date(new Date().getTime() - sixHoursInMS);
                        for (i = 0; i < containersDisksSizes.length; i++) {
                            if (containersDisksSizes[i].time >= sixHoursAgo) {
                                break;
                            }
                        }
                        containersDisksSizes = containersDisksSizes.slice(i);
                        callback(null, containersDisksSizes);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < containersDisksSizes.length; i++) {
                if (containersDisksSizes[i].time > object['time']) {
                    break;
                }
            }
            containersDisksSizes = __spreadArray(__spreadArray(__spreadArray([], containersDisksSizes.slice(0, i), true), [
                object
            ], false), containersDisksSizes.slice(i), true);
            var sixHoursAgo = new Date(new Date().getTime() - sixHoursInMS);
            for (i = 0; i < containersDisksSizes.length; i++) {
                if (containersDisksSizes[i].time >= sixHoursAgo) {
                    break;
                }
            }
            containersDisksSizes = containersDisksSizes.slice(i);
            callback(null, containersDisksSizes);
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.translateContainerStatsFromAPI = function (containerStats) {
        return {
            id: containerStats.id,
            container: containerStats.container,
            deployment: containerStats.deployment,
            time: new Date(containerStats.time),
            cpu: containerStats.cpu,
            ram: containerStats.ram,
            pid: containerStats.pid,
            netIn: containerStats.netIn,
            netOut: containerStats.netOut,
        };
    };
    Back4app2.prototype.findContainersStats = function (serviceEnvironmentId, from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n          query ContainersStats(\n            $serviceEnvironmentId: String!\n            $from: Date!\n            $to: Date\n          ) {\n            containersStats(\n              serviceEnvironmentId: $serviceEnvironmentId\n              from: $from\n              to: $to\n            ) {\n              id\n              container {\n                id\n                maxCPU\n                maxRAM\n                maxPID\n                maxDiskSize\n              }\n              deployment {\n                id\n              }\n              time\n              cpu\n              ram\n              pid\n              netIn\n              netOut\n            }\n          }\n        "], ["\n          query ContainersStats(\n            $serviceEnvironmentId: String!\n            $from: Date!\n            $to: Date\n          ) {\n            containersStats(\n              serviceEnvironmentId: $serviceEnvironmentId\n              from: $from\n              to: $to\n            ) {\n              id\n              container {\n                id\n                maxCPU\n                maxRAM\n                maxPID\n                maxDiskSize\n              }\n              deployment {\n                id\n              }\n              time\n              cpu\n              ram\n              pid\n              netIn\n              netOut\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    serviceEnvironmentId: serviceEnvironmentId,
                                    from: (from && from.toISOString()) || undefined,
                                    to: (to && to.toISOString()) || undefined,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['containersStats'].map(function (containerStats) {
                                return _this.translateContainerStatsFromAPI(containerStats);
                            })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToContainersStats = function (serviceEnvironmentId, timeWindow, callback) {
        var _this = this;
        var sixHoursInMS = 6 * 60 * 60 * 1000;
        if (timeWindow > sixHoursInMS) {
            throw new errors_1.InvalidInputError('The time window cannot be bigger than 6h');
        }
        var findContainersStats = this.findContainersStats.bind(this);
        var translateContainerStatsFromAPI = this.translateContainerStatsFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var containersStats;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n          subscription ContainerStatsEvents($serviceEnvironmentId: String!) {\n            containerStatsEvents(serviceEnvironmentId: $serviceEnvironmentId) {\n              kind\n              id\n              object {\n                id\n                container {\n                  id\n                  maxCPU\n                  maxRAM\n                  maxPID\n                  maxDiskSize\n                }\n                deployment {\n                  id\n                }\n                time\n                cpu\n                ram\n                pid\n                netIn\n                netOut\n              }\n            }\n          }\n        "], ["\n          subscription ContainerStatsEvents($serviceEnvironmentId: String!) {\n            containerStatsEvents(serviceEnvironmentId: $serviceEnvironmentId) {\n              kind\n              id\n              object {\n                id\n                container {\n                  id\n                  maxCPU\n                  maxRAM\n                  maxPID\n                  maxDiskSize\n                }\n                deployment {\n                  id\n                }\n                time\n                cpu\n                ram\n                pid\n                netIn\n                netOut\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                serviceEnvironmentId: serviceEnvironmentId,
            },
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['containerStatsEvents']['kind']) {
                    case 'INSERT':
                        insertObject(translateContainerStatsFromAPI(value.data['containerStatsEvents']['object']));
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, containersStats);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_8, sixHoursAgo, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findContainersStats(serviceEnvironmentId, timeWindow === sixHoursInMS
                                ? undefined
                                : new Date(new Date().getTime() - timeWindow))];
                    case 1:
                        containersStats = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_8 = _a.sent();
                        if (!(e_8 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_8, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        sixHoursAgo = new Date(new Date().getTime() - sixHoursInMS);
                        for (i = 0; i < containersStats.length; i++) {
                            if (containersStats[i].time >= sixHoursAgo) {
                                break;
                            }
                        }
                        containersStats = containersStats.slice(i);
                        callback(null, containersStats);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < containersStats.length; i++) {
                if (containersStats[i].time > object['time']) {
                    break;
                }
            }
            containersStats = __spreadArray(__spreadArray(__spreadArray([], containersStats.slice(0, i), true), [
                object
            ], false), containersStats.slice(i), true);
            var sixHoursAgo = new Date(new Date().getTime() - sixHoursInMS);
            for (i = 0; i < containersStats.length; i++) {
                if (containersStats[i].time >= sixHoursAgo) {
                    break;
                }
            }
            containersStats = containersStats.slice(i);
            callback(null, containersStats);
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.findDeployments = function (serviceEnvironmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n          query Deployments($serviceEnvironmentId: String!) {\n            deployments(serviceEnvironmentId: $serviceEnvironmentId) {\n              id\n              branchName\n              deployTask {\n                id\n                status\n                createdAt\n                startedAt\n                finishedAt\n                elapsedTimeMS\n              }\n              commitSHA\n              commitMessage\n              commitAuthorLogin\n              commitCommitterLogin\n              committedAt\n              status\n              createdAt\n            }\n          }\n        "], ["\n          query Deployments($serviceEnvironmentId: String!) {\n            deployments(serviceEnvironmentId: $serviceEnvironmentId) {\n              id\n              branchName\n              deployTask {\n                id\n                status\n                createdAt\n                startedAt\n                finishedAt\n                elapsedTimeMS\n              }\n              commitSHA\n              commitMessage\n              commitAuthorLogin\n              commitCommitterLogin\n              committedAt\n              status\n              createdAt\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    serviceEnvironmentId: serviceEnvironmentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['deployments'].map(function (deployment) {
                                return _this.translateDeploymentFromAPI(deployment);
                            })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToDeployments = function (serviceEnvironmentId, callback) {
        var _this = this;
        var findDeployments = this.findDeployments.bind(this);
        var translateDeploymentFromAPI = this.translateDeploymentFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var deployments;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n          subscription DeploymentEvents($serviceEnvironmentId: String!) {\n            deploymentEvents(serviceEnvironmentId: $serviceEnvironmentId) {\n              kind\n              id\n              object {\n                id\n                branchName\n                deployTask {\n                  id\n                  status\n                  createdAt\n                  startedAt\n                  finishedAt\n                  elapsedTimeMS\n                }\n                commitSHA\n                commitMessage\n                commitAuthorLogin\n                commitCommitterLogin\n                committedAt\n                status\n                createdAt\n              }\n            }\n          }\n        "], ["\n          subscription DeploymentEvents($serviceEnvironmentId: String!) {\n            deploymentEvents(serviceEnvironmentId: $serviceEnvironmentId) {\n              kind\n              id\n              object {\n                id\n                branchName\n                deployTask {\n                  id\n                  status\n                  createdAt\n                  startedAt\n                  finishedAt\n                  elapsedTimeMS\n                }\n                commitSHA\n                commitMessage\n                commitAuthorLogin\n                commitCommitterLogin\n                committedAt\n                status\n                createdAt\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                serviceEnvironmentId: serviceEnvironmentId,
            },
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['deploymentEvents']['kind']) {
                    case 'INSERT':
                        insertObject(translateDeploymentFromAPI(value.data['deploymentEvents']['object']));
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, deployments);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findDeployments(serviceEnvironmentId)];
                    case 1:
                        deployments = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_9 = _a.sent();
                        if (!(e_9 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_9, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, deployments);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < deployments.length; i++) {
                if (deployments[i].id <= object['id']) {
                    break;
                }
            }
            deployments = __spreadArray(__spreadArray(__spreadArray([], deployments.slice(0, i), true), [
                object
            ], false), deployments.slice(i), true);
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.deleteApp = function (appId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n          mutation deleteApp($appId: String!) {\n            deleteApp(appId: $appId)\n          }\n        "], ["\n          mutation deleteApp($appId: String!) {\n            deleteApp(appId: $appId)\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['deleteApp']];
                }
            });
        });
    };
    Back4app2.prototype.triggerManualDeployment = function (serviceEnvironmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n          mutation triggerManualDeployment($serviceEnvironmentId: String!) {\n            triggerManualDeployment(\n              serviceEnvironmentId: $serviceEnvironmentId\n            ) {\n              id\n              status\n              result\n              error {\n                message\n                code\n              }\n            }\n          }\n        "], ["\n          mutation triggerManualDeployment($serviceEnvironmentId: String!) {\n            triggerManualDeployment(\n              serviceEnvironmentId: $serviceEnvironmentId\n            ) {\n              id\n              status\n              result\n              error {\n                message\n                code\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    serviceEnvironmentId: serviceEnvironmentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        //TODO: maybe subscribe to that task!
                        return [2 /*return*/, result.data['triggerManualDeployment']];
                }
            });
        });
    };
    Back4app2.prototype.resendVerificationMail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n          mutation resendVerificationMail {\n            resendVerificationMail\n          }\n        "], ["\n          mutation resendVerificationMail {\n            resendVerificationMail\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['resendVerificationMail']];
                }
            });
        });
    };
    Back4app2.prototype.cancelDeploymentBuild = function (deploymentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n          mutation cancelDeploymentBuild($deploymentId: String!) {\n            cancelDeploymentBuild(deploymentId: $deploymentId) {\n              status\n            }\n          }\n        "], ["\n          mutation cancelDeploymentBuild($deploymentId: String!) {\n            cancelDeploymentBuild(deploymentId: $deploymentId) {\n              status\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    deploymentId: deploymentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['deploymentId']];
                }
            });
        });
    };
    Back4app2.prototype.updateAppFavourite = function (appId, isFavourite) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n          mutation updateAppFavourite($appId: String!, $isFavourite: Boolean!) {\n            updateAppFavourite(appId: $appId, isFavourite: $isFavourite) {\n              id\n              name\n              isFavourite\n            }\n          }\n        "], ["\n          mutation updateAppFavourite($appId: String!, $isFavourite: Boolean!) {\n            updateAppFavourite(appId: $appId, isFavourite: $isFavourite) {\n              id\n              name\n              isFavourite\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                    isFavourite: isFavourite,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['updateAppFavourite']];
                }
            });
        });
    };
    Back4app2.prototype.tryToFixDockerfileUsingAI = function (deploymentId) {
        return __awaiter(this, void 0, void 0, function () {
            var parseError, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parseError = this.parseError.bind(this);
                        return [4 /*yield*/, this.tryToExecute(function () {
                                return _this.apolloClient.query({
                                    query: (0, core_1.gql)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n          mutation tryToFixDockerfileErrorUsingAI($deploymentId: String!) {\n            tryToFixDockerfileErrorUsingAI(deploymentId: $deploymentId) {\n              id\n              status\n              result\n              error {\n                message\n                code\n              }\n            }\n          }\n        "], ["\n          mutation tryToFixDockerfileErrorUsingAI($deploymentId: String!) {\n            tryToFixDockerfileErrorUsingAI(deploymentId: $deploymentId) {\n              id\n              status\n              result\n              error {\n                message\n                code\n              }\n            }\n          }\n        "]))),
                                    fetchPolicy: 'no-cache',
                                    variables: {
                                        deploymentId: deploymentId,
                                    },
                                });
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var subscription = _this.apolloClient
                                    .subscribe({
                                    query: (0, core_1.gql)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n            subscription Task($taskId: String!) {\n              task(id: $taskId) {\n                status\n                result\n                error {\n                  message\n                  code\n                }\n              }\n            }\n          "], ["\n            subscription Task($taskId: String!) {\n              task(id: $taskId) {\n                status\n                result\n                error {\n                  message\n                  code\n                }\n              }\n            }\n          "]))),
                                    fetchPolicy: 'no-cache',
                                    variables: {
                                        taskId: result &&
                                            result.data &&
                                            result.data['tryToFixDockerfileErrorUsingAI'] &&
                                            result.data['tryToFixDockerfileErrorUsingAI']['id'],
                                    },
                                })
                                    .subscribe({
                                    next: function (value) {
                                        if (value.data['task']['status'] === 'DONE') {
                                            subscription.unsubscribe();
                                            resolve(JSON.parse(value.data['task']['result']));
                                        }
                                        else if (value.data['task']['status'] === 'FAILED') {
                                            subscription.unsubscribe();
                                            reject((0, errors_1.parseBack4app2Error)(value.data['task']['error'] || new errors_1.UnexpectedError()));
                                        }
                                    },
                                    error: function (error) {
                                        reject(parseError(error));
                                    },
                                });
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Back4app2.prototype.createPrWithDockerfileFix = function (deploymentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n          mutation CreatePrWithDockerfileFix($deploymentId: String!) {\n            createPrWithDockerfileFix(deploymentId: $deploymentId)\n          }\n        "], ["\n          mutation CreatePrWithDockerfileFix($deploymentId: String!) {\n            createPrWithDockerfileFix(deploymentId: $deploymentId)\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    deploymentId: deploymentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['createPrWithDockerfileFix']];
                }
            });
        });
    };
    Back4app2.prototype.findChatMessages = function (chatId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n          query chatMessages($chatId: String!) {\n            chatMessages(chatId: $chatId) {\n              id\n              question\n              askedAt\n              aiResponse\n              respondedAt\n              error {\n                code\n                message\n              }\n              status\n              attachments {\n                id\n                fileName\n                mimeType\n                sizeBytes\n                status\n                presignedUrl\n              }\n            }\n          }\n        "], ["\n          query chatMessages($chatId: String!) {\n            chatMessages(chatId: $chatId) {\n              id\n              question\n              askedAt\n              aiResponse\n              respondedAt\n              error {\n                code\n                message\n              }\n              status\n              attachments {\n                id\n                fileName\n                mimeType\n                sizeBytes\n                status\n                presignedUrl\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    chatId: chatId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['chatMessages'].map(function (chatMessage) {
                                return _this.translateChatMessageFromAPI(chatMessage);
                            })];
                }
            });
        });
    };
    Back4app2.prototype.findChatMessagesPaginated = function (chatId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var result, page;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            var _a;
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n          query chatMessagesPaginated($chatId: String!, $before: Date, $limit: Int) {\n            chatMessagesPaginated(chatId: $chatId, before: $before, limit: $limit) {\n              hasMore\n              nextBefore\n              items {\n                id\n                question\n                askedAt\n                aiResponse\n                respondedAt\n                error { code message }\n                status\n                attachments {\n                  id\n                  fileName\n                  mimeType\n                  sizeBytes\n                  status\n                  presignedUrl\n                }\n              }\n            }\n          }\n        "], ["\n          query chatMessagesPaginated($chatId: String!, $before: Date, $limit: Int) {\n            chatMessagesPaginated(chatId: $chatId, before: $before, limit: $limit) {\n              hasMore\n              nextBefore\n              items {\n                id\n                question\n                askedAt\n                aiResponse\n                respondedAt\n                error { code message }\n                status\n                attachments {\n                  id\n                  fileName\n                  mimeType\n                  sizeBytes\n                  status\n                  presignedUrl\n                }\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    chatId: chatId,
                                    before: options === null || options === void 0 ? void 0 : options.before,
                                    limit: (_a = options === null || options === void 0 ? void 0 : options.limit) !== null && _a !== void 0 ? _a : 20,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        page = result.data['chatMessagesPaginated'];
                        return [2 /*return*/, {
                                hasMore: page.hasMore,
                                nextBefore: page.nextBefore ? new Date(page.nextBefore) : undefined,
                                items: (page.items || []).map(function (m) { return _this.translateChatMessageFromAPI(m); }),
                            }];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToChatMessageEvents = function (chatId, callback) {
        var translateChatMessageFromAPI = this.translateChatMessageFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n          subscription chatMessageEvents($chatId: String!) {\n            chatMessageEvents(chatId: $chatId) {\n              kind\n              id\n              object {\n                id\n                question\n                askedAt\n                aiResponse\n                respondedAt\n                error { code message }\n                status\n                attachments {\n                  id\n                  fileName\n                  mimeType\n                  sizeBytes\n                  status\n                  presignedUrl\n                }\n              }\n            }\n          }\n        "], ["\n          subscription chatMessageEvents($chatId: String!) {\n            chatMessageEvents(chatId: $chatId) {\n              kind\n              id\n              object {\n                id\n                question\n                askedAt\n                aiResponse\n                respondedAt\n                error { code message }\n                status\n                attachments {\n                  id\n                  fileName\n                  mimeType\n                  sizeBytes\n                  status\n                  presignedUrl\n                }\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: { chatId: chatId },
        })
            .subscribe({
            next: function (value) {
                var ev = value.data['chatMessageEvents'];
                callback(null, {
                    kind: ev.kind,
                    id: ev.id,
                    object: ev.object ? translateChatMessageFromAPI(ev.object) : undefined,
                });
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        return { unsubscribe: function () { return subscription.unsubscribe(); } };
    };
    Back4app2.prototype.subscribeToChatMessages = function (chatId, callback) {
        var _this = this;
        var findChatMessages = this.findChatMessages.bind(this);
        var translateChatMessageFromAPI = this.translateChatMessageFromAPI.bind(this);
        var parseError = this.parseError.bind(this);
        var chatMessages = [];
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n          subscription chatMessageEvents($chatId: String!) {\n            chatMessageEvents(chatId: $chatId) {\n              id\n              kind\n              object {\n                id\n                question\n                askedAt\n                aiResponse\n                respondedAt\n                error {\n                  code\n                  message\n                }\n                status\n                attachments {\n                  id\n                  fileName\n                  mimeType\n                  sizeBytes\n                  status\n                  presignedUrl\n                }\n              }\n            }\n          }\n        "], ["\n          subscription chatMessageEvents($chatId: String!) {\n            chatMessageEvents(chatId: $chatId) {\n              id\n              kind\n              object {\n                id\n                question\n                askedAt\n                aiResponse\n                respondedAt\n                error {\n                  code\n                  message\n                }\n                status\n                attachments {\n                  id\n                  fileName\n                  mimeType\n                  sizeBytes\n                  status\n                  presignedUrl\n                }\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                chatId: chatId,
            },
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['chatMessageEvents']['kind']) {
                    case 'INSERT':
                    case 'UPDATE':
                    case 'ENTER':
                        removeObject(value.data['chatMessageEvents']['id']);
                        insertObject(translateChatMessageFromAPI(value.data['chatMessageEvents']['object']));
                        break;
                    case 'LEAVE':
                    case 'DELETE':
                        removeObject(value.data['chatMessageEvents']['id']);
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, chatMessages);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findChatMessages(chatId)];
                    case 1:
                        chatMessages = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_10 = _a.sent();
                        if (!(e_10 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_10, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, chatMessages);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < chatMessages.length; i++) {
                if (chatMessages[i].askedAt > object['askedAt']) {
                    break;
                }
            }
            chatMessages = __spreadArray(__spreadArray(__spreadArray([], chatMessages.slice(0, i), true), [
                object
            ], false), chatMessages.slice(i), true);
        };
        var removeObject = function (id) {
            var object = chatMessages.find(function (object) { return object.id === id; });
            if (object) {
                chatMessages.splice(chatMessages.indexOf(object), 1);
            }
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.findAgents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n          query agents {\n            agents {\n              id\n              name\n              status\n              currentAppId\n              currentPreviewWebHostingURL\n              currentAppName\n              currentAppDashboardURL\n              currentPublicWebHostingURL\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "], ["\n          query agents {\n            agents {\n              id\n              name\n              status\n              currentAppId\n              currentPreviewWebHostingURL\n              currentAppName\n              currentAppDashboardURL\n              currentPublicWebHostingURL\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['agents']];
                }
            });
        });
    };
    Back4app2.prototype.getAgent = function (agentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n          query agent($agentId: String!) {\n            agent(agentId: $agentId) {\n              id\n              name\n              status\n              currentAppId\n              currentPreviewWebHostingURL\n              currentAppName\n              currentAppDashboardURL\n              currentPublicWebHostingURL\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "], ["\n          query agent($agentId: String!) {\n            agent(agentId: $agentId) {\n              id\n              name\n              status\n              currentAppId\n              currentPreviewWebHostingURL\n              currentAppName\n              currentAppDashboardURL\n              currentPublicWebHostingURL\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "]))),
                                variables: { agentId: agentId },
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['agent']];
                }
            });
        });
    };
    /**
     * Get the current user's agents subscription information
     * Includes plan details, usage limits, and consumption data
     *
     * @returns AgentsSubscriptionInfo with plan and usage details
     */
    Back4app2.prototype.getMyAgentsSubscription = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n          query myAgentsSubscription {\n            myAgentsSubscription {\n              planName\n              planType\n              amountHardLimit\n              amountUsage\n              chatMessagesHardLimit\n              chatMessagesUsage\n              chatMessagesUsageResetAt\n              isPendingPayment\n            }\n          }\n        "], ["\n          query myAgentsSubscription {\n            myAgentsSubscription {\n              planName\n              planType\n              amountHardLimit\n              amountUsage\n              chatMessagesHardLimit\n              chatMessagesUsage\n              chatMessagesUsageResetAt\n              isPendingPayment\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['myAgentsSubscription']];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToAgents = function (callback) {
        var _this = this;
        var findAgents = this.findAgents.bind(this);
        var parseError = this.parseError.bind(this);
        var agents;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n          subscription AgentEvents {\n            agentEvents {\n              kind\n              id\n              object {\n                id\n                name\n                status\n                currentAppId\n                currentPreviewWebHostingURL\n                currentAppName\n                currentAppDashboardURL\n                currentPublicWebHostingURL\n                createdAt\n                mainChat {\n                  id\n                }\n              }\n            }\n          }\n        "], ["\n          subscription AgentEvents {\n            agentEvents {\n              kind\n              id\n              object {\n                id\n                name\n                status\n                currentAppId\n                currentPreviewWebHostingURL\n                currentAppName\n                currentAppDashboardURL\n                currentPublicWebHostingURL\n                createdAt\n                mainChat {\n                  id\n                }\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['agentEvents']['kind']) {
                    case 'INSERT':
                    case 'UPDATE':
                    case 'ENTER':
                        removeObject(value.data['agentEvents']['id']);
                        insertObject(value.data['agentEvents']['object']);
                        break;
                    case 'LEAVE':
                    case 'DELETE':
                        removeObject(value.data['agentEvents']['id']);
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, agents);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findAgents()];
                    case 1:
                        agents = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_11 = _a.sent();
                        if (!(e_11 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_11, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, agents);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < agents.length; i++) {
                if (agents[i].name <= object['name']) {
                    break;
                }
            }
            agents = __spreadArray(__spreadArray(__spreadArray([], agents.slice(0, i), true), [object], false), agents.slice(i), true);
        };
        var removeObject = function (id) {
            var object = agents.find(function (object) { return object.id === id; });
            if (object) {
                agents.splice(agents.indexOf(object), 1);
            }
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
                console.log('unsubscribed for agents');
            },
        };
    };
    Back4app2.prototype.createAgent = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n          mutation createAgent($name: String) {\n            createAgent(name: $name) {\n              id\n              name\n              status\n              currentAppId\n              currentPreviewWebHostingURL\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "], ["\n          mutation createAgent($name: String) {\n            createAgent(name: $name) {\n              id\n              name\n              status\n              currentAppId\n              currentPreviewWebHostingURL\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    name: name,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.translateAgentFromAPI(result.data['createAgent'])];
                }
            });
        });
    };
    Back4app2.prototype.updateAgent = function (agentId, name, currentPublicWebHostingURL) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n          mutation updateAgent(\n            $agentId: String!\n            $name: String!\n            $currentPublicWebHostingURL: String\n          ) {\n            updateAgent(\n              agentId: $agentId\n              name: $name\n              currentPublicWebHostingURL: $currentPublicWebHostingURL\n            ) {\n              id\n              name\n              status\n              currentAppId\n              currentPreviewWebHostingURL\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "], ["\n          mutation updateAgent(\n            $agentId: String!\n            $name: String!\n            $currentPublicWebHostingURL: String\n          ) {\n            updateAgent(\n              agentId: $agentId\n              name: $name\n              currentPublicWebHostingURL: $currentPublicWebHostingURL\n            ) {\n              id\n              name\n              status\n              currentAppId\n              currentPreviewWebHostingURL\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    agentId: agentId,
                                    name: name,
                                    currentPublicWebHostingURL: currentPublicWebHostingURL,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.translateAgentFromAPI(result.data['updateAgent'])];
                }
            });
        });
    };
    Back4app2.prototype.setAgentCurrentApp = function (agentId, appId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n          mutation setAgentCurrentApp($agentId: String!, $appId: String!) {\n            setAgentCurrentApp(agentId: $agentId, appId: $appId) {\n              id\n              name\n              status\n              currentAppId\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "], ["\n          mutation setAgentCurrentApp($agentId: String!, $appId: String!) {\n            setAgentCurrentApp(agentId: $agentId, appId: $appId) {\n              id\n              name\n              status\n              currentAppId\n              createdAt\n              mainChat {\n                id\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: { agentId: agentId, appId: appId },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.translateAgentFromAPI(result.data['setAgentCurrentApp'])];
                }
            });
        });
    };
    Back4app2.prototype.deleteAgent = function (agentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n          mutation deleteAgent($agentId: String!) {\n            deleteAgent(agentId: $agentId)\n          }\n        "], ["\n          mutation deleteAgent($agentId: String!) {\n            deleteAgent(agentId: $agentId)\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    agentId: agentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['deleteAgent']];
                }
            });
        });
    };
    Back4app2.prototype.askQuestionToAgent = function (agentId, question, attachmentIds) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n          mutation AskQuestionToAgent(\n            $agentId: String!\n            $question: String!\n            $attachmentIds: [String!]\n          ) {\n            askQuestionToAgent(\n              agentId: $agentId\n              question: $question\n              attachmentIds: $attachmentIds\n            ) {\n              id\n              question\n              askedAt\n              aiResponse\n              respondedAt\n              error {\n                code\n                message\n              }\n              attachments {\n                id\n                fileName\n                mimeType\n                sizeBytes\n                presignedUrl\n              }\n            }\n          }\n        "], ["\n          mutation AskQuestionToAgent(\n            $agentId: String!\n            $question: String!\n            $attachmentIds: [String!]\n          ) {\n            askQuestionToAgent(\n              agentId: $agentId\n              question: $question\n              attachmentIds: $attachmentIds\n            ) {\n              id\n              question\n              askedAt\n              aiResponse\n              respondedAt\n              error {\n                code\n                message\n              }\n              attachments {\n                id\n                fileName\n                mimeType\n                sizeBytes\n                presignedUrl\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    agentId: agentId,
                                    question: question,
                                    attachmentIds: attachmentIds,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.translateChatMessageFromAPI(result.data['askQuestionToAgent'])];
                }
            });
        });
    };
    /**
     * Stops an ongoing agent response generation.
     *
     * @param chatMessageId - The ID of the chat message to stop
     * @returns Task if slow path (can be subscribed to), null if fast path succeeded immediately
     */
    Back4app2.prototype.stopAgentResponse = function (chatMessageId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, taskData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n          mutation StopAgentResponse($chatMessageId: String!) {\n            stopAgentResponse(chatMessageId: $chatMessageId) {\n              id\n              status\n              createdAt\n              startedAt\n              finishedAt\n              elapsedTimeMS\n            }\n          }\n        "], ["\n          mutation StopAgentResponse($chatMessageId: String!) {\n            stopAgentResponse(chatMessageId: $chatMessageId) {\n              id\n              status\n              createdAt\n              startedAt\n              finishedAt\n              elapsedTimeMS\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    chatMessageId: chatMessageId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        taskData = result.data['stopAgentResponse'];
                        return [2 /*return*/, taskData ? this.translateTaskFromAPI(taskData) : null];
                }
            });
        });
    };
    /**
     * Subscribes to task status updates.
     *
     * @param taskId - The ID of the task to subscribe to
     * @param callback - Called when task status changes or errors occur
     * @returns Subscription that can be unsubscribed
     */
    Back4app2.prototype.subscribeToTask = function (taskId, callback) {
        var _this = this;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n          subscription Task($taskId: String!) {\n            task(id: $taskId) {\n              id\n              status\n              createdAt\n              startedAt\n              finishedAt\n              elapsedTimeMS\n              error {\n                message\n                code\n              }\n            }\n          }\n        "], ["\n          subscription Task($taskId: String!) {\n            task(id: $taskId) {\n              id\n              status\n              createdAt\n              startedAt\n              finishedAt\n              elapsedTimeMS\n              error {\n                message\n                code\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                taskId: taskId,
            },
        })
            .subscribe({
            next: function (value) {
                var task = _this.translateTaskFromAPI(value.data['task']);
                if (task.status === TaskStatus.FAILED) {
                    var error = (0, errors_1.parseBack4app2Error)(value.data['task']['error']);
                    callback(error || new errors_1.UnexpectedError(), task);
                }
                else {
                    callback(undefined, task);
                }
            },
            error: function (error) {
                callback(_this.parseError(error), undefined);
            },
        });
        return {
            unsubscribe: function () {
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.createAgentPrompt = function (name, content, description) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n          mutation CreateAgentPrompt($content: String!, $name: String) {\n            createAgentPrompt(content: $content, name: $name) {\n              content\n              createdAt\n              description\n              id\n              name\n            }\n          }\n        "], ["\n          mutation CreateAgentPrompt($content: String!, $name: String) {\n            createAgentPrompt(content: $content, name: $name) {\n              content\n              createdAt\n              description\n              id\n              name\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    name: name,
                                    content: content,
                                    description: description,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['createAgentPrompt']];
                }
            });
        });
    };
    Back4app2.prototype.findAgentPrompts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n          query AgentsPrompts {\n            agentsPrompts {\n              content\n              createdAt\n              description\n              id\n              name\n            }\n          }\n        "], ["\n          query AgentsPrompts {\n            agentsPrompts {\n              content\n              createdAt\n              description\n              id\n              name\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['agentsPrompts']];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToAgentPrompts = function (callback) {
        var _this = this;
        var findAgentPrompts = this.findAgentPrompts.bind(this);
        var parseError = this.parseError.bind(this);
        var agentPrompts;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n          subscription AgentPromptEvents {\n            agentPromptEvents {\n              kind\n              id\n              object {\n                id\n                name\n                content\n                description\n                createdAt\n              }\n            }\n          }\n        "], ["\n          subscription AgentPromptEvents {\n            agentPromptEvents {\n              kind\n              id\n              object {\n                id\n                name\n                content\n                description\n                createdAt\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['agentPromptEvents']['kind']) {
                    case 'INSERT':
                    case 'UPDATE':
                    case 'ENTER':
                        removeObject(value.data['agentPromptEvents']['id']);
                        insertObject(value.data['agentPromptEvents']['object']);
                        break;
                    case 'LEAVE':
                    case 'DELETE':
                        removeObject(value.data['agentPromptEvents']['id']);
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, agentPrompts);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, findAgentPrompts()];
                    case 1:
                        agentPrompts = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_12 = _a.sent();
                        if (!(e_12 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_12, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, agentPrompts);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            var i;
            for (i = 0; i < agentPrompts.length; i++) {
                if (agentPrompts[i].name <= object['name']) {
                    break;
                }
            }
            agentPrompts = __spreadArray(__spreadArray(__spreadArray([], agentPrompts.slice(0, i), true), [
                object
            ], false), agentPrompts.slice(i), true);
        };
        var removeObject = function (id) {
            var object = agentPrompts.find(function (object) { return object.id === id; });
            if (object) {
                agentPrompts.splice(agentPrompts.indexOf(object), 1);
            }
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.redirectToAgent = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.mutate({
                                mutation: (0, core_1.gql)(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n          mutation RedirectToAgent($query: String!) {\n            redirectToAgent(query: $query) {\n              id\n              createdAt\n              mainChat {\n                id\n                error {\n                  code\n                  message\n                }\n              }\n              name\n              status\n            }\n          }\n        "], ["\n          mutation RedirectToAgent($query: String!) {\n            redirectToAgent(query: $query) {\n              id\n              createdAt\n              mainChat {\n                id\n                error {\n                  code\n                  message\n                }\n              }\n              name\n              status\n            }\n          }\n        "]))),
                                variables: { query: query },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.translateAgentFromAPI(result.data['redirectToAgent'])];
                }
            });
        });
    };
    Back4app2.prototype.getOnBoardingQuestions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n          query GetOnBoardingQuestions {\n            getOnBoardingQuestions {\n              onBoardingQues {\n                id\n                answers {\n                  answer\n                  date\n                  question\n                }\n              }\n              isFirstLogin\n            }\n          }\n        "], ["\n          query GetOnBoardingQuestions {\n            getOnBoardingQuestions {\n              onBoardingQues {\n                id\n                answers {\n                  answer\n                  date\n                  question\n                }\n              }\n              isFirstLogin\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getOnBoardingQuestions']];
                }
            });
        });
    };
    Back4app2.prototype.saveOnBoardingQuestions = function (questionSetId, questions) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n          mutation SaveOnBoardingQuestions(\n            $questionSetId: String!\n            $questions: [QuestionInput!]!\n          ) {\n            saveOnBoardingQuestions(\n              questionSetId: $questionSetId\n              questions: $questions\n            ) {\n              id\n              answers {\n                answer\n                date\n                question\n              }\n            }\n          }\n        "], ["\n          mutation SaveOnBoardingQuestions(\n            $questionSetId: String!\n            $questions: [QuestionInput!]!\n          ) {\n            saveOnBoardingQuestions(\n              questionSetId: $questionSetId\n              questions: $questions\n            ) {\n              id\n              answers {\n                answer\n                date\n                question\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    questionSetId: questionSetId,
                                    questions: questions,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['saveOnBoardingQuestions']];
                }
            });
        });
    };
    Back4app2.prototype.getOnboardingProductSuggestion = function (userInput) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n          mutation GetOnboardingProductSuggestion($userInput: String!) {\n            getOnboardingProductSuggestion(userInput: $userInput) {\n              id\n              chatType\n            }\n          }\n        "], ["\n          mutation GetOnboardingProductSuggestion($userInput: String!) {\n            getOnboardingProductSuggestion(userInput: $userInput) {\n              id\n              chatType\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    userInput: userInput,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getOnboardingProductSuggestion']];
                }
            });
        });
    };
    Back4app2.prototype.getOnboardingChatId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n          query Query {\n            getOnboardingChatId\n          }\n        "], ["\n          query Query {\n            getOnboardingChatId\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getOnboardingChatId']];
                }
            });
        });
    };
    Back4app2.prototype.listParseVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n          query Query {\n            listParseVersion {\n              newAccount\n              showCaptcha\n              parseVersionList {\n                description\n                id\n                version\n              }\n            }\n          }\n        "], ["\n          query Query {\n            listParseVersion {\n              newAccount\n              showCaptcha\n              parseVersionList {\n                description\n                id\n                version\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['listParseVersion']];
                }
            });
        });
    };
    Back4app2.prototype.createParseApp = function (appName, isPublic, parseVersion, reCaptcha, database) {
        return __awaiter(this, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_63 || (templateObject_63 = __makeTemplateObject(["\n          mutation CreateParseApp(\n            $appName: String!\n            $database: DATABASE!\n            $parseVersion: String!\n            $isPublic: Boolean!\n            $reCaptcha: String\n          ) {\n            createParseApp(\n              appName: $appName\n              database: $database\n              isPublic: $isPublic\n              parseVersion: $parseVersion\n              reCaptcha: $reCaptcha\n            ) {\n              appId\n              appName\n              dashboardAPI\n              id\n              masterKey\n              restKey\n            }\n          }\n        "], ["\n          mutation CreateParseApp(\n            $appName: String!\n            $database: DATABASE!\n            $parseVersion: String!\n            $isPublic: Boolean!\n            $reCaptcha: String\n          ) {\n            createParseApp(\n              appName: $appName\n              database: $database\n              isPublic: $isPublic\n              parseVersion: $parseVersion\n              reCaptcha: $reCaptcha\n            ) {\n              appId\n              appName\n              dashboardAPI\n              id\n              masterKey\n              restKey\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appName: appName,
                                    isPublic: isPublic,
                                    parseVersion: parseVersion,
                                    reCaptcha: reCaptcha,
                                    database: database,
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['createParseApp']];
                    case 2:
                        error_1 = _a.sent();
                        throw this.parseError(error_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // --- Parse App lookups (Back4App dashboard) ---
    /**
     * Returns the raw payload from Back4App's `/listApps` endpoint.
     *
     * This is intentionally untyped for now because Back4App returns a heterogeneous
     * list (Parse apps + legacy Back4App apps + collaboration metadata + plan/migration data).
     * The dashboard can filter/shape this data as needed.
     */
    Back4app2.prototype.getParseApps = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_64 || (templateObject_64 = __makeTemplateObject(["\n          query GetParseApps {\n            getParseApps\n          }\n        "], ["\n          query GetParseApps {\n            getParseApps\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getParseApps'] || []];
                }
            });
        });
    };
    /**
     * Links a Back4App Parse App (by Back4App dashboard internal id/UUID) to an Agent.
     * The server will fetch app metadata and store the required "current app" fields on the agent.
     */
    Back4app2.prototype.setAgentCurrentParseApp = function (agentId, dashboardId, deployPublic) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_65 || (templateObject_65 = __makeTemplateObject(["\n          mutation SetAgentCurrentParseApp(\n            $agentId: String!\n            $dashboardId: String!\n            $deployPublic: Boolean\n          ) {\n            setAgentCurrentParseApp(agentId: $agentId, dashboardId: $dashboardId, deployPublic: $deployPublic) {\n              id\n              name\n              status\n              currentAppId\n              currentAppName\n              currentAppDashboardURL\n              currentPreviewWebHostingURL\n              currentPublicWebHostingURL\n              mainChat {\n                id\n              }\n            }\n          }\n        "], ["\n          mutation SetAgentCurrentParseApp(\n            $agentId: String!\n            $dashboardId: String!\n            $deployPublic: Boolean\n          ) {\n            setAgentCurrentParseApp(agentId: $agentId, dashboardId: $dashboardId, deployPublic: $deployPublic) {\n              id\n              name\n              status\n              currentAppId\n              currentAppName\n              currentAppDashboardURL\n              currentPreviewWebHostingURL\n              currentPublicWebHostingURL\n              mainChat {\n                id\n              }\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: { agentId: agentId, dashboardId: dashboardId, deployPublic: deployPublic !== null && deployPublic !== void 0 ? deployPublic : null },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['setAgentCurrentParseApp']];
                }
            });
        });
    };
    Back4app2.prototype.getParseAppInfo = function (parseAppId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_66 || (templateObject_66 = __makeTemplateObject(["\n          query ParseAppInfo($parseAppId: String!) {\n            parseAppInfo(parseAppId: $parseAppId) {\n              id\n              appId\n              appName\n              masterKey\n              readOnlyMasterKey\n              restKey\n              javascriptKey\n              clientKey\n              dotnetKey\n              fileKey\n              webhookKey\n              dashboardAPI\n              jobAPI\n              previewURL\n              status\n              parseVersion\n              mongoVersion\n              databaseVersion\n              database\n              emailSettings {\n                fromEmail\n                verificationSubject\n                passwordResetSubject\n              }\n              createdAt\n              lastBuilt\n              deployedAt\n              synchronizedAt\n            }\n          }\n        "], ["\n          query ParseAppInfo($parseAppId: String!) {\n            parseAppInfo(parseAppId: $parseAppId) {\n              id\n              appId\n              appName\n              masterKey\n              readOnlyMasterKey\n              restKey\n              javascriptKey\n              clientKey\n              dotnetKey\n              fileKey\n              webhookKey\n              dashboardAPI\n              jobAPI\n              previewURL\n              status\n              parseVersion\n              mongoVersion\n              databaseVersion\n              database\n              emailSettings {\n                fromEmail\n                verificationSubject\n                passwordResetSubject\n              }\n              createdAt\n              lastBuilt\n              deployedAt\n              synchronizedAt\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: { parseAppId: parseAppId },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['parseAppInfo']];
                }
            });
        });
    };
    Back4app2.prototype.getPlanData = function (appId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_67 || (templateObject_67 = __makeTemplateObject(["\n          query GetAppPlanData($appId: String!) {\n            getAppPlanData(appId: $appId) {\n              planName\n              checkoutPlanId\n              checkoutPriceKey\n              price\n              canChangeSubdomain\n            }\n          }\n        "], ["\n          query GetAppPlanData($appId: String!) {\n            getAppPlanData(appId: $appId) {\n              planName\n              checkoutPlanId\n              checkoutPriceKey\n              price\n              canChangeSubdomain\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: { appId: appId },
                                context: {
                                    headers: {
                                        'X-Application-ID': appId,
                                        'X-Application-Type': 'parse',
                                    },
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getAppPlanData']];
                }
            });
        });
    };
    Back4app2.prototype.getParseAppOwnerEmail = function (parseAppId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_68 || (templateObject_68 = __makeTemplateObject(["\n          query GetParseAppOwnerEmail($parseAppId: String!) {\n            getParseAppOwnerEmail(parseAppId: $parseAppId) {\n              ownerEmail\n            }\n          }\n        "], ["\n          query GetParseAppOwnerEmail($parseAppId: String!) {\n            getParseAppOwnerEmail(parseAppId: $parseAppId) {\n              ownerEmail\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: { parseAppId: parseAppId },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getParseAppOwnerEmail']];
                }
            });
        });
    };
    Back4app2.prototype.getParseAppDomains = function (parseAppId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_69 || (templateObject_69 = __makeTemplateObject(["\n          query ParseAppDomains($parseAppId: String!) {\n            parseAppDomains(parseAppId: $parseAppId) {\n              webhost\n              domains\n            }\n          }\n        "], ["\n          query ParseAppDomains($parseAppId: String!) {\n            parseAppDomains(parseAppId: $parseAppId) {\n              webhost\n              domains\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: { parseAppId: parseAppId },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['parseAppDomains']];
                }
            });
        });
    };
    Back4app2.prototype.preCheckSubdomain = function (parseAppId, subdomainName, currentSubdomainName) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_70 || (templateObject_70 = __makeTemplateObject(["\n          query PreCheckSubdomain(\n            $parseAppId: String!\n            $subdomainName: String!\n            $currentSubdomainName: String\n          ) {\n            preCheckSubdomain(\n              parseAppId: $parseAppId\n              subdomainName: $subdomainName\n              currentSubdomainName: $currentSubdomainName\n            ) {\n              available\n            }\n          }\n        "], ["\n          query PreCheckSubdomain(\n            $parseAppId: String!\n            $subdomainName: String!\n            $currentSubdomainName: String\n          ) {\n            preCheckSubdomain(\n              parseAppId: $parseAppId\n              subdomainName: $subdomainName\n              currentSubdomainName: $currentSubdomainName\n            ) {\n              available\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    parseAppId: parseAppId,
                                    subdomainName: subdomainName,
                                    currentSubdomainName: currentSubdomainName || null,
                                },
                            });
                        })];
                    case 1:
                        result = _c.sent();
                        return [2 /*return*/, Boolean((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.preCheckSubdomain) === null || _b === void 0 ? void 0 : _b.available)];
                }
            });
        });
    };
    Back4app2.prototype.publishAppSubdomain = function (parseAppId, subdomainName, currentSubdomainName) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_71 || (templateObject_71 = __makeTemplateObject(["\n          mutation PublishAppSubdomain(\n            $parseAppId: String!\n            $subdomainName: String!\n            $currentSubdomainName: String\n          ) {\n            publishAppSubdomain(\n              parseAppId: $parseAppId\n              subdomainName: $subdomainName\n              currentSubdomainName: $currentSubdomainName\n            )\n          }\n        "], ["\n          mutation PublishAppSubdomain(\n            $parseAppId: String!\n            $subdomainName: String!\n            $currentSubdomainName: String\n          ) {\n            publishAppSubdomain(\n              parseAppId: $parseAppId\n              subdomainName: $subdomainName\n              currentSubdomainName: $currentSubdomainName\n            )\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    parseAppId: parseAppId,
                                    subdomainName: subdomainName,
                                    currentSubdomainName: currentSubdomainName || null,
                                },
                            });
                        })];
                    case 1:
                        result = _b.sent();
                        return [2 /*return*/, (_a = result.data) === null || _a === void 0 ? void 0 : _a.publishAppSubdomain];
                }
            });
        });
    };
    Back4app2.prototype.transposeToAIAgent = function (chatId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_72 || (templateObject_72 = __makeTemplateObject(["\n          mutation TransposeConversationToAgent($chatId: String!) {\n            transposeConversationToAgent(chatId: $chatId) {\n              id\n              mainChat {\n                id\n                error {\n                  code\n                  message\n                }\n              }\n              name\n              status\n              createdAt\n            }\n          }\n        "], ["\n          mutation TransposeConversationToAgent($chatId: String!) {\n            transposeConversationToAgent(chatId: $chatId) {\n              id\n              mainChat {\n                id\n                error {\n                  code\n                  message\n                }\n              }\n              name\n              status\n              createdAt\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    chatId: chatId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.translateAgentFromAPI(result.data['transposeConversationToAgent'])];
                }
            });
        });
    };
    Back4app2.prototype.createStripeSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_73 || (templateObject_73 = __makeTemplateObject(["\n          query CreateStripeSession {\n            createStripeSession\n          }\n        "], ["\n          query CreateStripeSession {\n            createStripeSession\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        console.log(result);
                        return [2 /*return*/, result.data['createStripeSession']];
                }
            });
        });
    };
    Back4app2.prototype.stripeSessionStatus = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_74 || (templateObject_74 = __makeTemplateObject(["\n          mutation StripeSessionStatus($sessionId: String!) {\n            stripeSessionStatus(sessionId: $sessionId)\n          }\n        "], ["\n          mutation StripeSessionStatus($sessionId: String!) {\n            stripeSessionStatus(sessionId: $sessionId)\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    sessionId: sessionId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        console.log(result);
                        return [2 /*return*/, result.data['stripeSessionStatus']];
                }
            });
        });
    };
    Back4app2.prototype.getMcpKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_75 || (templateObject_75 = __makeTemplateObject(["\n          query GetMcpKey {\n            getMcpKey\n          }\n        "], ["\n          query GetMcpKey {\n            getMcpKey\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getMcpKey']];
                }
            });
        });
    };
    Back4app2.prototype.getPlans = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_76 || (templateObject_76 = __makeTemplateObject(["\n          query GetPlans {\n            getPlans {\n              id\n              maxCPU\n              maxRAM\n              name\n              price\n              tagline\n              transferLimit\n              checkoutPriceKey\n              checkoutPlanId\n            }\n          }\n        "], ["\n          query GetPlans {\n            getPlans {\n              id\n              maxCPU\n              maxRAM\n              name\n              price\n              tagline\n              transferLimit\n              checkoutPriceKey\n              checkoutPlanId\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getPlans']];
                }
            });
        });
    };
    Back4app2.prototype.validateEmail = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_77 || (templateObject_77 = __makeTemplateObject(["\n          query ValidateEmail($email: String!) {\n            validateEmail(email: $email)\n          }\n        "], ["\n          query ValidateEmail($email: String!) {\n            validateEmail(email: $email)\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: { email: email },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['validateEmail']];
                }
            });
        });
    };
    Back4app2.prototype.addCollaborator = function (appId, email, permissions) {
        return __awaiter(this, void 0, void 0, function () {
            var result, collaborator;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_78 || (templateObject_78 = __makeTemplateObject(["\n          mutation AddCollaborator(\n            $appId: String!\n            $email: String!\n            $permissions: ContainersPermissionInput!\n          ) {\n            addCollaborator(\n              appId: $appId\n              email: $email\n              permissions: $permissions\n            ) {\n              id\n              userEmail\n              appId\n              isPending\n              containersPermission {\n                Overview\n                Logs\n                Deployments\n                Metrics\n                Settings {\n                  General\n                  BuildAndDeploy\n                  EnvVars\n                  Domain\n                  HealthAndAlert\n                }\n                Actions {\n                  Deploy\n                }\n              }\n              createdAt\n              updatedAt\n            }\n          }\n        "], ["\n          mutation AddCollaborator(\n            $appId: String!\n            $email: String!\n            $permissions: ContainersPermissionInput!\n          ) {\n            addCollaborator(\n              appId: $appId\n              email: $email\n              permissions: $permissions\n            ) {\n              id\n              userEmail\n              appId\n              isPending\n              containersPermission {\n                Overview\n                Logs\n                Deployments\n                Metrics\n                Settings {\n                  General\n                  BuildAndDeploy\n                  EnvVars\n                  Domain\n                  HealthAndAlert\n                }\n                Actions {\n                  Deploy\n                }\n              }\n              createdAt\n              updatedAt\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                    email: email,
                                    permissions: permissions,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        collaborator = result.data['addCollaborator'];
                        return [2 /*return*/, {
                                id: collaborator.id,
                                email: collaborator.userEmail,
                                permissions: collaborator.containersPermission,
                                isPending: collaborator.isPending,
                                createdAt: new Date(collaborator.createdAt),
                                updatedAt: new Date(collaborator.updatedAt),
                            }];
                }
            });
        });
    };
    Back4app2.prototype.sendInviteToCollaborator = function (appId, email, permissions) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_79 || (templateObject_79 = __makeTemplateObject(["\n          mutation SendInviteToCollaborator(\n            $appId: String!\n            $email: String!\n            $permissions: ContainersPermissionInput!\n          ) {\n            sendInviteToCollaborator(\n              appId: $appId\n              email: $email\n              permissions: $permissions\n            ) {\n              id\n              userEmail\n              appId\n              isPending\n              containersPermission {\n                Overview\n                Logs\n                Deployments\n                Metrics\n                Settings {\n                  General\n                  BuildAndDeploy\n                  EnvVars\n                  Domain\n                  HealthAndAlert\n                }\n                Actions {\n                  Deploy\n                }\n              }\n              createdAt\n              updatedAt\n            }\n          }\n        "], ["\n          mutation SendInviteToCollaborator(\n            $appId: String!\n            $email: String!\n            $permissions: ContainersPermissionInput!\n          ) {\n            sendInviteToCollaborator(\n              appId: $appId\n              email: $email\n              permissions: $permissions\n            ) {\n              id\n              userEmail\n              appId\n              isPending\n              containersPermission {\n                Overview\n                Logs\n                Deployments\n                Metrics\n                Settings {\n                  General\n                  BuildAndDeploy\n                  EnvVars\n                  Domain\n                  HealthAndAlert\n                }\n                Actions {\n                  Deploy\n                }\n              }\n              createdAt\n              updatedAt\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                    email: email,
                                    permissions: permissions,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['sendInviteToCollaborator']];
                }
            });
        });
    };
    Back4app2.prototype.updateCollaboratorPermission = function (appId, email, permissions) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_80 || (templateObject_80 = __makeTemplateObject(["\n          mutation UpdateCollaboratorPermission(\n            $appId: String!\n            $email: String!\n            $permissions: ContainersPermissionInput!\n          ) {\n            updateCollaboratorPermission(\n              appId: $appId\n              email: $email\n              permissions: $permissions\n            ) {\n              id\n              userEmail\n              appId\n              isPending\n              containersPermission {\n                Overview\n                Logs\n                Deployments\n                Metrics\n                Settings {\n                  General\n                  BuildAndDeploy\n                  EnvVars\n                  Domain\n                  HealthAndAlert\n                }\n                Actions {\n                  Deploy\n                }\n              }\n              createdAt\n              updatedAt\n            }\n          }\n        "], ["\n          mutation UpdateCollaboratorPermission(\n            $appId: String!\n            $email: String!\n            $permissions: ContainersPermissionInput!\n          ) {\n            updateCollaboratorPermission(\n              appId: $appId\n              email: $email\n              permissions: $permissions\n            ) {\n              id\n              userEmail\n              appId\n              isPending\n              containersPermission {\n                Overview\n                Logs\n                Deployments\n                Metrics\n                Settings {\n                  General\n                  BuildAndDeploy\n                  EnvVars\n                  Domain\n                  HealthAndAlert\n                }\n                Actions {\n                  Deploy\n                }\n              }\n              createdAt\n              updatedAt\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                    email: email,
                                    permissions: permissions,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['updateCollaboratorPermission']];
                }
            });
        });
    };
    Back4app2.prototype.removeCollaborator = function (appId, email) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_81 || (templateObject_81 = __makeTemplateObject(["\n          mutation RemoveCollaborator($appId: String!, $email: String!) {\n            removeCollaborator(appId: $appId, email: $email)\n          }\n        "], ["\n          mutation RemoveCollaborator($appId: String!, $email: String!) {\n            removeCollaborator(appId: $appId, email: $email)\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                    email: email,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['removeCollaborator']];
                }
            });
        });
    };
    Back4app2.prototype.listCollaborators = function (appId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, collaborators;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_82 || (templateObject_82 = __makeTemplateObject(["\n          query ListAppCollaborators($appId: String!) {\n            listAppCollaborators(appId: $appId) {\n              id\n              userEmail\n              containersPermission {\n                Overview\n                Logs\n                Deployments\n                Metrics\n                Settings {\n                  General\n                  BuildAndDeploy\n                  EnvVars\n                  Domain\n                  HealthAndAlert\n                }\n                Actions {\n                  Deploy\n                }\n              }\n              isPending\n              createdAt\n              updatedAt\n            }\n          }\n        "], ["\n          query ListAppCollaborators($appId: String!) {\n            listAppCollaborators(appId: $appId) {\n              id\n              userEmail\n              containersPermission {\n                Overview\n                Logs\n                Deployments\n                Metrics\n                Settings {\n                  General\n                  BuildAndDeploy\n                  EnvVars\n                  Domain\n                  HealthAndAlert\n                }\n                Actions {\n                  Deploy\n                }\n              }\n              isPending\n              createdAt\n              updatedAt\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        collaborators = result.data['listAppCollaborators'] || [];
                        return [2 /*return*/, collaborators.map(function (collaborator) { return ({
                                id: collaborator.id,
                                email: collaborator.userEmail,
                                permissions: collaborator.containersPermission,
                                isPending: collaborator.isPending,
                                createdAt: new Date(collaborator.createdAt),
                                updatedAt: new Date(collaborator.updatedAt),
                            }); })];
                }
            });
        });
    };
    Back4app2.prototype.subscribeToCollaborators = function (appId, callback) {
        var _this = this;
        var listCollaborators = this.listCollaborators.bind(this);
        var parseError = this.parseError.bind(this);
        var collaborators;
        var subscription = this.apolloClient
            .subscribe({
            query: (0, core_1.gql)(templateObject_83 || (templateObject_83 = __makeTemplateObject(["\n          subscription CollaboratorEvents($appId: String!) {\n            collaboratorEvents(appId: $appId) {\n              kind\n              id\n              object {\n                id\n                userEmail\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n                isPending\n                createdAt\n                updatedAt\n              }\n            }\n          }\n        "], ["\n          subscription CollaboratorEvents($appId: String!) {\n            collaboratorEvents(appId: $appId) {\n              kind\n              id\n              object {\n                id\n                userEmail\n                containersPermission {\n                  Overview\n                  Logs\n                  Deployments\n                  Metrics\n                  Settings {\n                    General\n                    BuildAndDeploy\n                    EnvVars\n                    Domain\n                    HealthAndAlert\n                  }\n                  Actions {\n                    Deploy\n                  }\n                }\n                isPending\n                createdAt\n                updatedAt\n              }\n            }\n          }\n        "]))),
            fetchPolicy: 'no-cache',
            variables: {
                appId: appId,
            },
        })
            .subscribe({
            start: function () {
                sendSnapshot();
            },
            next: function (value) {
                if (sendSnapshotCount > 0) {
                    sendSnapshot();
                    return;
                }
                switch (value.data['collaboratorEvents']['kind']) {
                    case 'INSERT':
                        insertObject(value.data['collaboratorEvents']['object']);
                        break;
                    case 'UPDATE':
                        updateObject(value.data['collaboratorEvents']['id'], value.data['collaboratorEvents']['object']);
                        break;
                    case 'DELETE':
                        deleteObject(value.data['collaboratorEvents']['id']);
                        break;
                    case 'ERROR':
                        sendSnapshot();
                        return;
                }
                callback(null, collaborators);
            },
            error: function (error) {
                callback(parseError(error));
            },
        });
        var sendSnapshotPromise = Promise.resolve();
        var sendSnapshotCount = 0;
        var sendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var sendSnapshotPromiseAux;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sendSnapshotCount++;
                        sendSnapshotPromiseAux = sendSnapshotPromise.then(function () {
                            return doSendSnapshot();
                        });
                        sendSnapshotPromise = sendSnapshotPromiseAux;
                        return [4 /*yield*/, sendSnapshotPromiseAux];
                    case 1:
                        _a.sent();
                        sendSnapshotCount--;
                        return [2 /*return*/];
                }
            });
        }); };
        var doSendSnapshot = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, listCollaborators(appId)];
                    case 1:
                        collaborators = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_13 = _a.sent();
                        if (!(e_13 instanceof errors_1.NetworkError) || !this.isReconnecting) {
                            callback(e_13, null);
                        }
                        return [2 /*return*/];
                    case 3:
                        callback(null, collaborators);
                        return [2 /*return*/];
                }
            });
        }); };
        var insertObject = function (object) {
            if (!object)
                return;
            var translatedCollaborator = {
                id: object.id,
                email: object.userEmail,
                permissions: object.containersPermission,
                isPending: object.isPending,
                createdAt: new Date(object.createdAt),
                updatedAt: new Date(object.updatedAt),
            };
            var i;
            for (i = 0; i < collaborators.length; i++) {
                if (collaborators[i].id === translatedCollaborator.id) {
                    break;
                }
            }
            collaborators = __spreadArray(__spreadArray(__spreadArray([], collaborators.slice(0, i), true), [
                translatedCollaborator
            ], false), collaborators.slice(i), true);
        };
        var updateObject = function (id, object) {
            if (!object)
                return;
            var translatedCollaborator = {
                id: object.id,
                email: object.userEmail,
                permissions: object.containersPermission,
                isPending: object.isPending,
                createdAt: new Date(object.createdAt),
                updatedAt: new Date(object.updatedAt),
            };
            var index = collaborators.findIndex(function (collaborator) { return collaborator.id === id; });
            if (index >= 0) {
                // Replace in place to maintain position
                collaborators = __spreadArray(__spreadArray(__spreadArray([], collaborators.slice(0, index), true), [
                    translatedCollaborator
                ], false), collaborators.slice(index + 1), true);
            }
            else {
                // If not found, insert at the end
                insertObject(object);
            }
        };
        var deleteObject = function (id) {
            var index = collaborators.findIndex(function (collaborator) { return collaborator.id === id; });
            if (index >= 0) {
                collaborators = __spreadArray(__spreadArray([], collaborators.slice(0, index), true), collaborators.slice(index + 1), true);
            }
        };
        var onConnected = this.onConnected;
        onConnected.push(sendSnapshot);
        sendSnapshot();
        return {
            unsubscribe: function () {
                onConnected.splice(onConnected.indexOf(sendSnapshot), 1);
                subscription.unsubscribe();
            },
        };
    };
    Back4app2.prototype.getAppOwnerEmail = function (appId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_84 || (templateObject_84 = __makeTemplateObject(["\n          query GetAppOwnerEmail($appId: String!) {\n            getAppOwnerEmail(appId: $appId)\n          }\n        "], ["\n          query GetAppOwnerEmail($appId: String!) {\n            getAppOwnerEmail(appId: $appId)\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    appId: appId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['getAppOwnerEmail']];
                }
            });
        });
    };
    Back4app2.prototype.requestPresignedUrl = function (chatId, fileName, mimeType, sizeBytes, width, height) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_85 || (templateObject_85 = __makeTemplateObject(["\n          mutation RequestPresignedUrl(\n            $chatId: String!\n            $fileName: String!\n            $mimeType: String!\n            $sizeBytes: Int!\n            $width: Int!\n            $height: Int!\n          ) {\n            requestPresignedUrl(\n              chatId: $chatId\n              fileName: $fileName\n              mimeType: $mimeType\n              sizeBytes: $sizeBytes\n              width: $width\n              height: $height\n            ) {\n              attachmentId\n              presignedUrl\n            }\n          }\n        "], ["\n          mutation RequestPresignedUrl(\n            $chatId: String!\n            $fileName: String!\n            $mimeType: String!\n            $sizeBytes: Int!\n            $width: Int!\n            $height: Int!\n          ) {\n            requestPresignedUrl(\n              chatId: $chatId\n              fileName: $fileName\n              mimeType: $mimeType\n              sizeBytes: $sizeBytes\n              width: $width\n              height: $height\n            ) {\n              attachmentId\n              presignedUrl\n            }\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    chatId: chatId,
                                    fileName: fileName,
                                    mimeType: mimeType,
                                    sizeBytes: sizeBytes,
                                    width: width,
                                    height: height,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['requestPresignedUrl']];
                }
            });
        });
    };
    Back4app2.prototype.deleteAttachment = function (attachmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tryToExecute(function () {
                            return _this.apolloClient.query({
                                query: (0, core_1.gql)(templateObject_86 || (templateObject_86 = __makeTemplateObject(["\n          mutation DeleteAttachment($attachmentId: String!) {\n            deleteAttachment(attachmentId: $attachmentId)\n          }\n        "], ["\n          mutation DeleteAttachment($attachmentId: String!) {\n            deleteAttachment(attachmentId: $attachmentId)\n          }\n        "]))),
                                fetchPolicy: 'no-cache',
                                variables: {
                                    attachmentId: attachmentId,
                                },
                            });
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data['deleteAttachment']];
                }
            });
        });
    };
    return Back4app2;
}());
exports.default = Back4app2;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79, templateObject_80, templateObject_81, templateObject_82, templateObject_83, templateObject_84, templateObject_85, templateObject_86;
